export const OpenAISVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.7324 13.1125C29.0653 12.1254 29.1808 11.0779 29.0707 10.042C28.9607 9.00611 28.6279 8.00628 28.0951 7.11112C26.4724 4.32445 23.2124 2.88979 20.0284 3.56445C19.3232 2.78365 18.4607 2.161 17.4975 1.73746C16.5344 1.31393 15.4925 1.0991 14.4404 1.10712C11.1858 1.10045 8.29776 3.16845 7.29642 6.22445C6.26716 6.43049 5.29347 6.85303 4.43995 7.46403C3.58643 8.07504 2.87258 8.86055 2.34575 9.76845C1.54946 11.1208 1.20914 12.6934 1.37504 14.254C1.54094 15.8145 2.20427 17.2804 3.26709 18.4351C2.93377 19.4223 2.81803 20.4699 2.92781 21.5061C3.03759 22.5422 3.3703 23.5424 3.90309 24.4378C5.52575 27.2245 8.78575 28.6578 11.9698 27.9845C12.6747 28.7651 13.5371 29.3876 14.5 29.8109C15.4629 30.2342 16.5046 30.4488 17.5564 30.4405C20.8138 30.4485 23.7031 28.3791 24.7044 25.3205C25.7344 25.1145 26.7087 24.6917 27.5628 24.0802C28.4168 23.4687 29.1309 22.6825 29.6578 21.7738C30.4525 20.4215 30.7918 18.8496 30.6254 17.29C30.459 15.7303 29.7959 14.2653 28.7338 13.1111L28.7324 13.1125ZM17.5578 28.5231C16.2572 28.5263 14.9962 28.0765 13.9911 27.2511C14.0364 27.2271 14.1151 27.1845 14.1671 27.1525L20.0871 23.7791C20.2348 23.6967 20.3578 23.5761 20.4431 23.43C20.5285 23.2839 20.5731 23.1176 20.5724 22.9485V14.7138L23.0751 16.1391C23.1018 16.1525 23.1191 16.1778 23.1231 16.2058V23.0258C23.1191 26.0578 20.6298 28.5165 17.5578 28.5231ZM5.58842 23.4805C4.93592 22.3705 4.7005 21.0643 4.92442 19.7965C4.96709 19.8231 5.04442 19.8698 5.09909 19.9005L11.0191 23.2738C11.3191 23.4471 11.6911 23.4471 11.9924 23.2738L19.2191 19.1565V22.0071C19.2197 22.0218 19.2167 22.0363 19.2104 22.0495C19.2042 22.0628 19.1948 22.0743 19.1831 22.0831L13.1991 25.4911C10.5338 27.0058 7.12975 26.1045 5.58975 23.4778L5.58842 23.4805ZM4.02976 10.7285C4.68481 9.61112 5.71106 8.75898 6.92976 8.32045L6.92709 8.52179V15.2685C6.92627 15.4378 6.97086 15.6044 7.05621 15.7507C7.14157 15.897 7.26457 16.0178 7.41242 16.1005L14.6391 20.2165L12.1378 21.6431C12.1254 21.6511 12.1112 21.6558 12.0966 21.657C12.0819 21.6581 12.0672 21.6557 12.0538 21.6498L6.06842 18.2378C3.40842 16.7178 2.49642 13.3605 4.02842 10.7311L4.02976 10.7285ZM24.5858 15.4485L17.3591 11.3311L19.8604 9.90712C19.8727 9.89897 19.8868 9.89397 19.9014 9.89258C19.9161 9.89118 19.9308 9.89343 19.9444 9.89912L25.9298 13.3085C28.5938 14.8285 29.5071 18.1911 27.9684 20.8191C27.3128 21.9358 26.2874 22.788 25.0698 23.2285V16.2805C25.0706 16.1114 25.0262 15.9452 24.941 15.7991C24.8559 15.653 24.7333 15.5324 24.5858 15.4498V15.4485ZM27.0751 11.7511C27.0169 11.7157 26.9582 11.681 26.8991 11.6471L20.9791 8.27379C20.8312 8.18874 20.6637 8.14397 20.4931 8.14397C20.3225 8.14397 20.1549 8.18874 20.0071 8.27379L12.7804 12.3911V9.54045C12.7798 9.52582 12.7828 9.51126 12.7891 9.49803C12.7953 9.48479 12.8047 9.47327 12.8164 9.46445L18.7991 6.05779C21.4658 4.54179 24.8724 5.44445 26.4084 8.07512C27.0578 9.18579 27.2951 10.4871 27.0751 11.7511ZM11.4204 16.8311L8.91776 15.4071C8.90469 15.4007 8.89345 15.3911 8.88506 15.3793C8.87667 15.3674 8.87141 15.3536 8.86976 15.3391V8.51912C8.87109 5.48312 11.3671 3.02312 14.4444 3.02579C15.7458 3.02579 17.0044 3.47645 18.0058 4.29779C17.9604 4.32179 17.8831 4.36445 17.8311 4.39512L11.9111 7.76845C11.7631 7.85073 11.6399 7.9712 11.5543 8.1173C11.4687 8.2634 11.4238 8.42979 11.4244 8.59912L11.4204 16.8298V16.8311ZM12.7804 13.9405L15.9991 12.1071L19.2178 13.9405V17.6071L15.9991 19.4405L12.7791 17.6071V13.9405H12.7804Z"
      fill="currentColor"
    />
  </svg>
);

export const LlamaIndexSVG = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <g clipPath="url(#llamaindex-clip)">
      <path
        d="M26.8964,0 L5.1037,0 C2.2851,0 0,2.2851 0,5.1037 L0,26.8964 C0,29.7148 2.2851,32 5.1037,32 L26.8964,32 C29.7148,32 32,29.7148 32,26.8964 L32,5.1037 C32,2.2851 29.7148,0 26.8964,0"
        fill="#000000"
      />
      <path
        d="M24.3207,27.6347 C24.3207,27.6347 25.7326,25.2836 22.429,23.5993 C22.429,23.5993 23.0686,26.1138 21.5716,28.4444 L20.0336,28.4444 C20.0336,28.4444 19.9655,27.9545 20.6155,27.7061 C21.9764,27.182 22.0308,24.9467 21.6327,24.6779 C20.4181,23.8613 19.9383,23.1639 20.2514,21.3877 C20.2514,21.3877 18.1486,22.1568 15.5356,21.8267 C15.3995,21.8096 15.2668,21.8743 15.1987,21.9934 C15.0592,22.235 14.7768,22.6704 14.3107,23.174 C14.3107,23.174 14.1916,24.5657 13.8786,25.5557 C13.8786,25.5557 13.9977,27.2501 13.569,28.4411 L11.7316,28.4411 C11.7316,28.4411 11.7521,27.7028 12.6367,27.6075 C13.7187,27.4917 12.4427,24.1268 12.4427,24.1268 C12.4427,24.1268 12.3883,25.9607 11.2859,28.4343 L9.8807,28.4343 C9.8807,28.4343 9.8807,27.7196 10.5952,27.5428 C11.7554,27.2535 11.2383,25.1644 11.0511,24.0043 C10.864,22.8405 10.602,20.6665 9.6527,19.4585 C8.7034,18.2507 8.2203,18.261 8.1625,16.0425 C8.1625,16.0425 7.3561,14.77 7.6453,13.0926 C7.6453,13.0926 7.0431,11.0783 7.9481,8.1012 C7.9481,8.1012 5.808,7.6657 5.7671,7.1349 C5.7229,6.6041 5.8828,6.0019 6.4544,5.9509 C7.026,5.8998 7.8631,5.8148 7.8665,5.2125 C7.8665,4.6103 7.1383,3.8107 7.5909,3.576 C8.0128,3.3548 8.5027,4.7804 8.8259,4.5559 C9.0369,4.4096 8.2509,3.6406 8.7647,3.7461 C8.9756,3.7903 10.7653,4.3823 11.371,7.5058 C11.9766,10.6292 11.7248,12.7149 12.5993,12.7149 C13.4737,12.7149 17.4716,12.5686 19.8057,13.1402 C22.1397,13.7118 22.235,14.6067 23.2592,14.3481 C24.2832,14.0895 25.4604,13.4703 26.1273,15.7397 C26.7159,17.7369 25.0624,17.4852 25.0624,18.1113 C25.0624,18.7372 24.8412,19.707 25.093,20.299 C25.3449,20.891 25.2053,22.32 25.4265,23.1298 C25.6476,23.9396 25.9131,24.6745 25.4128,25.7191 C25.4128,25.7191 25.6578,27.4782 25.1067,28.4444 L23.7797,28.4444 C23.7797,28.4444 23.6844,27.8932 24.3308,27.6347 L24.3207,27.6347"
        fill="url(#llamaindex-gradient)"
      />
    </g>
    <defs>
      <linearGradient
        id="llamaindex-gradient"
        x1="4.8009"
        y1="4.2394"
        x2="24.1063"
        y2="30.03"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#37D7FA" />
        <stop offset="0.4" stopColor="#4B72FE" />
        <stop offset="0.68" stopColor="#FF8DF2" />
        <stop offset="1" stopColor="#FF8705" />
      </linearGradient>
      <clipPath id="llamaindex-clip">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LangChainSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_844_2456)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.6007 0C29.1348 0.000375618 31.9996 2.86523 32 6.39931V25.6007C31.9996 29.1348 29.1348 31.9996 25.6007 32H6.39931C2.86523 31.9996 0.000375618 29.1348 0 25.6007V6.39931C0.00037516 2.86523 2.86523 0.00037516 6.39931 0H25.6007ZM10.4184 16.1337C8.1615 18.3909 8.16186 22.0499 10.4184 24.3073C12.6759 26.5647 16.3363 26.5647 18.5938 24.3073L21.4514 21.4497L18.7274 18.7257L15.8698 21.5851C15.117 22.3376 13.8954 22.3376 13.1424 21.5851C12.3898 20.8322 12.3898 19.6105 13.1424 18.8576L16.0017 15.9983L13.2778 13.2743L10.4184 16.1337ZM21.5833 7.69097C19.326 5.43425 15.667 5.43412 13.4097 7.69097L10.5503 10.5503L13.2743 13.2743L16.1337 10.4149C16.8866 9.66241 18.1083 9.66228 18.8611 10.4149C19.6135 11.1678 19.6136 12.3895 18.8611 13.1424L16.0017 15.9983L18.7257 18.724L21.5833 15.8663C23.8408 13.6089 23.8408 9.94841 21.5833 7.69097Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_844_2456">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LangGraphSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#langgraph_clip_path)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.6007 0C29.1348 0.00037516 31.9996 2.86523 32 6.39931V25.6007C31.9996 29.1348 29.1348 31.9996 25.6007 32H6.39931C2.86524 31.9996 0.000375619 29.1348 0 25.6007V6.39931C0.00037516 2.86523 2.86524 0.000376535 6.39931 0H25.6007ZM10.2882 17.5295C7.97727 17.5295 6.10243 19.4027 6.10243 21.7135C6.10263 24.0243 7.97738 25.8976 10.2882 25.8976C12.5981 25.8971 14.4711 24.025 14.4722 21.7153H10.2882V17.5295ZM21.7153 21.7153H17.5313C17.5323 24.0251 19.4052 25.8974 21.7153 25.8976C24.0261 25.8975 25.8991 24.0242 25.8993 21.7135C25.8993 19.4027 24.0262 17.5296 21.7153 17.5295V21.7153ZM10.2882 6.10417C7.97731 6.10417 6.1025 7.9773 6.10243 10.2882C6.10249 12.599 7.9773 14.4722 10.2882 14.4722V10.2882H14.4722C14.4718 7.97788 12.5984 6.10458 10.2882 6.10417ZM21.7153 6.10417C19.4048 6.10435 17.5317 7.97774 17.5313 10.2882H21.7153V14.4722C24.0262 14.4722 25.8992 12.599 25.8993 10.2882C25.8992 7.97733 24.0261 6.10422 21.7153 6.10417Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="langgraph_clip_path">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const HaystackSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.5341 0H2.46593C1.10403 0 0 1.10403 0 2.46593V29.5341C0 30.896 1.10403 32 2.46593 32H29.5341C30.896 32 32 30.896 32 29.5341V2.46593C32 1.10403 30.896 0 29.5341 0Z"
      fill="#0EAF9C"
    />
    <path
      d="M24.1471 21.3058C24.1471 21.4934 23.9942 21.6447 23.806 21.6447C22.1086 21.6447 20.7328 20.2777 20.7328 18.5913V13.1026C20.7328 10.6667 18.7453 8.69255 16.2944 8.69255C13.8435 8.69255 11.9651 10.6674 11.9651 13.1026V15.1358C11.9611 15.3197 12.1082 15.4716 12.2925 15.4749C12.2951 15.4749 12.2971 15.4749 12.2997 15.4749H14.2389C14.4271 15.4787 14.5833 15.33 14.5872 15.1424C14.5872 15.1398 14.5872 15.1378 14.5872 15.1352V13.0201C14.5872 12.083 15.3513 11.3239 16.2944 11.3239C17.2375 11.3239 18.0016 12.083 18.0016 13.0201V25.7697C17.9976 25.9606 17.8388 26.1126 17.6466 26.1086C15.9571 26.1086 14.5872 24.7475 14.5872 23.0689C14.5872 23.0643 14.5872 23.0597 14.5872 23.0552V18.9842C14.5833 18.7958 14.4284 18.6451 14.2389 18.6451H12.2997C12.1147 18.6451 11.9651 18.7939 11.9651 18.9776C11.9651 18.9802 11.9651 18.9822 11.9651 18.9848V20.342C11.9651 22.0285 10.4801 23.3955 8.78276 23.3955C8.59391 23.3955 8.44165 23.2436 8.44165 23.0565V13.1033C8.44165 8.79386 11.9572 5.30078 16.2944 5.30078C20.6315 5.30078 24.1471 8.79386 24.1471 13.1033V21.3058Z"
      fill="white"
    />
  </svg>
);

export const MistralAISVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1112_37203)">
      <path d="M29.0909 0H23.2727V6.39251H29.0909V0Z" fill="black" />
      <path d="M32 0H26.1818V6.39251H32V0Z" fill="#F7D046" />
      <path d="M5.81818 0H0V6.39251H5.81818V0Z" fill="black" />
      <path d="M5.81818 6.39258H0V12.7851H5.81818V6.39258Z" fill="black" />
      <path d="M5.81818 12.7852H0V19.1777H5.81818V12.7852Z" fill="black" />
      <path d="M5.81818 19.1777H0V25.5702H5.81818V19.1777Z" fill="black" />
      <path d="M5.81818 25.5698H0V31.9623H5.81818V25.5698Z" fill="black" />
      <path d="M8.7273 0H2.90912V6.39251H8.7273V0Z" fill="#F7D046" />
      <path d="M32 6.39258H26.1818V12.7851H32V6.39258Z" fill="#F2A73B" />
      <path
        d="M8.7273 6.39258H2.90912V12.7851H8.7273V6.39258Z"
        fill="#F2A73B"
      />
      <path
        d="M23.2727 6.39258H17.4545V12.7851H23.2727V6.39258Z"
        fill="black"
      />
      <path
        d="M26.1818 6.39258H20.3636V12.7851H26.1818V6.39258Z"
        fill="#F2A73B"
      />
      <path
        d="M14.5455 6.39258H8.72729V12.7851H14.5455V6.39258Z"
        fill="#F2A73B"
      />
      <path
        d="M20.3637 12.7852H14.5455V19.1777H20.3637V12.7852Z"
        fill="#EE792F"
      />
      <path
        d="M26.1818 12.7852H20.3636V19.1777H26.1818V12.7852Z"
        fill="#EE792F"
      />
      <path
        d="M14.5455 12.7852H8.72729V19.1777H14.5455V12.7852Z"
        fill="#EE792F"
      />
      <path
        d="M17.4545 19.1777H11.6364V25.5702H17.4545V19.1777Z"
        fill="black"
      />
      <path
        d="M20.3637 19.1777H14.5455V25.5702H20.3637V19.1777Z"
        fill="#EB5829"
      />
      <path d="M32 12.7852H26.1818V19.1777H32V12.7852Z" fill="#EE792F" />
      <path
        d="M8.7273 12.7852H2.90912V19.1777H8.7273V12.7852Z"
        fill="#EE792F"
      />
      <path
        d="M29.0909 19.1777H23.2727V25.5702H29.0909V19.1777Z"
        fill="black"
      />
      <path d="M32 19.1777H26.1818V25.5702H32V19.1777Z" fill="#EB5829" />
      <path
        d="M29.0909 25.5698H23.2727V31.9623H29.0909V25.5698Z"
        fill="black"
      />
      <path
        d="M8.7273 19.1777H2.90912V25.5702H8.7273V19.1777Z"
        fill="#EB5829"
      />
      <path d="M32 25.5698H26.1818V31.9623H32V25.5698Z" fill="#EA3326" />
      <path
        d="M8.7273 25.5698H2.90912V31.9623H8.7273V25.5698Z"
        fill="#EA3326"
      />
    </g>
    <defs>
      <clipPath id="clip0_1112_37203">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const VertexAISVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.6667 18.52C26.5078 18.3292 26.2852 18.2025 26.04 18.1633C25.7949 18.1241 25.5438 18.175 25.3333 18.3067L16 25.16V25.4533C16.1347 25.4374 16.2712 25.4501 16.4005 25.4908C16.5299 25.5314 16.6492 25.5989 16.7506 25.689C16.852 25.7791 16.9331 25.8896 16.9887 26.0133C17.0442 26.137 17.0729 26.2711 17.0729 26.4067C17.0729 26.5423 17.0442 26.6763 16.9887 26.8C16.9331 26.9237 16.852 27.0342 16.7506 27.1243C16.6492 27.2144 16.5299 27.2819 16.4005 27.3226C16.2712 27.3632 16.1347 27.3759 16 27.36C16.2165 27.361 16.4274 27.2907 16.6 27.16L26.48 19.8667C26.6725 19.7053 26.7982 19.4781 26.8327 19.2293C26.8672 18.9804 26.808 18.7277 26.6667 18.52Z"
      fill="#669DF6"
    />
    <path
      d="M16 27.3598C15.7666 27.3322 15.5514 27.2198 15.3953 27.0441C15.2392 26.8684 15.153 26.6415 15.153 26.4065C15.153 26.1714 15.2392 25.9446 15.3953 25.7689C15.5514 25.5931 15.7666 25.4808 16 25.4532V25.1598L6.66669 18.3065C6.45707 18.172 6.20525 18.1194 5.95931 18.1587C5.71337 18.1981 5.49054 18.3266 5.33335 18.5198C5.19277 18.7276 5.13659 18.981 5.17621 19.2287C5.21584 19.4764 5.34831 19.6997 5.54669 19.8532L15.4267 27.1465C15.5952 27.2753 15.8012 27.3455 16.0134 27.3465L16 27.3598Z"
      fill="#AECBFA"
    />
    <path
      d="M16 24.4531C15.6123 24.4531 15.2334 24.5681 14.9111 24.7834C14.5887 24.9988 14.3375 25.3049 14.1892 25.6631C14.0408 26.0212 14.002 26.4153 14.0776 26.7955C14.1533 27.1757 14.3399 27.5249 14.614 27.7991C14.8882 28.0732 15.2374 28.2598 15.6176 28.3355C15.9978 28.4111 16.3919 28.3723 16.75 28.2239C17.1082 28.0756 17.4143 27.8244 17.6297 27.502C17.845 27.1797 17.96 26.8008 17.96 26.4131C17.96 25.8933 17.7535 25.3948 17.3859 25.0272C17.0183 24.6596 16.5198 24.4531 16 24.4531ZM16 27.3598C15.8095 27.3598 15.6234 27.3031 15.4653 27.197C15.3071 27.0909 15.1841 26.9402 15.1119 26.764C15.0396 26.5878 15.0214 26.3941 15.0595 26.2075C15.0977 26.021 15.1904 25.85 15.326 25.7162C15.4616 25.5825 15.6339 25.4922 15.821 25.4566C16.0081 25.4211 16.2015 25.442 16.3767 25.5168C16.5519 25.5915 16.7008 25.7166 16.8047 25.8762C16.9086 26.0358 16.9626 26.2227 16.96 26.4131C16.96 26.5386 16.9351 26.6628 16.8867 26.7785C16.8383 26.8942 16.7673 26.9992 16.678 27.0873C16.5887 27.1754 16.4827 27.2448 16.3663 27.2916C16.25 27.3384 16.1254 27.3616 16 27.3598Z"
      fill="#4285F4"
    />
    <path
      d="M8.00001 8.14679C7.73587 8.14333 7.48352 8.03687 7.29673 7.85008C7.10993 7.66328 7.00347 7.41093 7.00001 7.14679V4.64012C6.98365 4.4982 6.99749 4.35441 7.04061 4.21821C7.08373 4.08201 7.15517 3.95647 7.25023 3.84982C7.34529 3.74317 7.46183 3.65782 7.5922 3.59939C7.72256 3.54095 7.86382 3.51074 8.00668 3.51074C8.14955 3.51074 8.2908 3.54095 8.42117 3.59939C8.55153 3.65782 8.66807 3.74317 8.76313 3.84982C8.85819 3.95647 8.92963 4.08201 8.97275 4.21821C9.01587 4.35441 9.02971 4.4982 9.01335 4.64012V7.14679C9.00984 7.41322 8.90153 7.66756 8.71188 7.85472C8.52222 8.04188 8.26647 8.14681 8.00001 8.14679Z"
      fill="#AECBFA"
    />
    <path
      d="M7.97336 17.0135C8.533 17.0135 8.98669 16.5598 8.98669 16.0002C8.98669 15.4405 8.533 14.9868 7.97336 14.9868C7.41371 14.9868 6.96002 15.4405 6.96002 16.0002C6.96002 16.5598 7.41371 17.0135 7.97336 17.0135Z"
      fill="#AECBFA"
    />
    <path
      d="M7.97336 14.0667C8.533 14.0667 8.98669 13.613 8.98669 13.0534C8.98669 12.4937 8.533 12.04 7.97336 12.04C7.41371 12.04 6.96002 12.4937 6.96002 13.0534C6.96002 13.613 7.41371 14.0667 7.97336 14.0667Z"
      fill="#AECBFA"
    />
    <path
      d="M7.97336 11.1067C8.533 11.1067 8.98669 10.6531 8.98669 10.0934C8.98669 9.53376 8.533 9.08008 7.97336 9.08008C7.41371 9.08008 6.96002 9.53376 6.96002 10.0934C6.96002 10.6531 7.41371 11.1067 7.97336 11.1067Z"
      fill="#AECBFA"
    />
    <path
      d="M24 11.0801C23.7336 11.0766 23.4792 10.9682 23.2921 10.7786C23.1049 10.5889 23 10.3332 23 10.0667V7.56006C23 7.29484 23.1054 7.04049 23.2929 6.85295C23.4804 6.66542 23.7348 6.56006 24 6.56006C24.2652 6.56006 24.5196 6.66542 24.7071 6.85295C24.8946 7.04049 25 7.29484 25 7.56006V10.0667C25.0018 10.1992 24.9772 10.3306 24.9277 10.4535C24.8783 10.5764 24.8049 10.6882 24.7119 10.7825C24.6188 10.8767 24.508 10.9516 24.3858 11.0027C24.2636 11.0538 24.1325 11.0801 24 11.0801Z"
      fill="#4285F4"
    />
    <path
      d="M24.0266 17.0267C24.5863 17.0267 25.04 16.573 25.04 16.0133C25.04 15.4537 24.5863 15 24.0266 15C23.467 15 23.0133 15.4537 23.0133 16.0133C23.0133 16.573 23.467 17.0267 24.0266 17.0267Z"
      fill="#4285F4"
    />
    <path
      d="M24.0266 14.0267C24.5863 14.0267 25.04 13.573 25.04 13.0133C25.04 12.4537 24.5863 12 24.0266 12C23.467 12 23.0133 12.4537 23.0133 13.0133C23.0133 13.573 23.467 14.0267 24.0266 14.0267Z"
      fill="#4285F4"
    />
    <path
      d="M24.0266 5.65313C24.5863 5.65313 25.04 5.19945 25.04 4.6398C25.04 4.08015 24.5863 3.62646 24.0266 3.62646C23.467 3.62646 23.0133 4.08015 23.0133 4.6398C23.0133 5.19945 23.467 5.65313 24.0266 5.65313Z"
      fill="#4285F4"
    />
    <path
      d="M16 20.0001C15.7359 19.9967 15.4835 19.8902 15.2967 19.7034C15.1099 19.5166 15.0035 19.2642 15 19.0001V16.4534C15.0285 16.2064 15.1468 15.9785 15.3324 15.813C15.518 15.6476 15.758 15.5562 16.0067 15.5562C16.2553 15.5562 16.4953 15.6476 16.6809 15.813C16.8665 15.9785 16.9849 16.2064 17.0133 16.4534V18.9734C17.0151 19.1076 16.9902 19.2408 16.9401 19.3653C16.8899 19.4898 16.8156 19.6031 16.7213 19.6986C16.627 19.7941 16.5147 19.87 16.3909 19.9217C16.2671 19.9735 16.1342 20.0001 16 20.0001Z"
      fill="#669DF6"
    />
    <path
      d="M16 22.9466C16.5597 22.9466 17.0134 22.4929 17.0134 21.9333C17.0134 21.3736 16.5597 20.9199 16 20.9199C15.4404 20.9199 14.9867 21.3736 14.9867 21.9333C14.9867 22.4929 15.4404 22.9466 16 22.9466Z"
      fill="#669DF6"
    />
    <path
      d="M16 14.5335C16.5597 14.5335 17.0134 14.0798 17.0134 13.5202C17.0134 12.9605 16.5597 12.5068 16 12.5068C15.4404 12.5068 14.9867 12.9605 14.9867 13.5202C14.9867 14.0798 15.4404 14.5335 16 14.5335Z"
      fill="#669DF6"
    />
    <path
      d="M16 11.5735C16.5597 11.5735 17.0134 11.1199 17.0134 10.5602C17.0134 10.0006 16.5597 9.54688 16 9.54688C15.4404 9.54688 14.9867 10.0006 14.9867 10.5602C14.9867 11.1199 15.4404 11.5735 16 11.5735Z"
      fill="#669DF6"
    />
    <path
      d="M20 14.0535C19.7359 14.0501 19.4835 13.9436 19.2967 13.7568C19.1099 13.57 19.0035 13.3177 19 13.0535V10.5469C18.9837 10.4049 18.9975 10.2612 19.0406 10.125C19.0837 9.98875 19.1552 9.8632 19.2502 9.75655C19.3453 9.64991 19.4618 9.56456 19.5922 9.50613C19.7226 9.44769 19.8638 9.41748 20.0067 9.41748C20.1495 9.41748 20.2908 9.44769 20.4212 9.50613C20.5515 9.56456 20.6681 9.64991 20.7631 9.75655C20.8582 9.8632 20.9296 9.98875 20.9728 10.125C21.0159 10.2612 21.0297 10.4049 21.0133 10.5469V13.0535C21.0098 13.32 20.9015 13.5743 20.7119 13.7615C20.5222 13.9486 20.2665 14.0535 20 14.0535Z"
      fill="#4285F4"
    />
    <path
      d="M20.0133 8.59991C20.573 8.59991 21.0267 8.14622 21.0267 7.58658C21.0267 7.02693 20.573 6.57324 20.0133 6.57324C19.4537 6.57324 19 7.02693 19 7.58658C19 8.14622 19.4537 8.59991 20.0133 8.59991Z"
      fill="#4285F4"
    />
    <path
      d="M20.0133 19.9334C20.573 19.9334 21.0267 19.4797 21.0267 18.9201C21.0267 18.3604 20.573 17.9067 20.0133 17.9067C19.4537 17.9067 19 18.3604 19 18.9201C19 19.4797 19.4537 19.9334 20.0133 19.9334Z"
      fill="#4285F4"
    />
    <path
      d="M20.0133 16.9734C20.573 16.9734 21.0267 16.5198 21.0267 15.9601C21.0267 15.4005 20.573 14.9468 20.0133 14.9468C19.4537 14.9468 19 15.4005 19 15.9601C19 16.5198 19.4537 16.9734 20.0133 16.9734Z"
      fill="#4285F4"
    />
    <path
      d="M11.9867 19.9334C12.5463 19.9334 13 19.4797 13 18.9201C13 18.3604 12.5463 17.9067 11.9867 17.9067C11.427 17.9067 10.9733 18.3604 10.9733 18.9201C10.9733 19.4797 11.427 19.9334 11.9867 19.9334Z"
      fill="#AECBFA"
    />
    <path
      d="M11.9867 11.5735C12.5463 11.5735 13 11.1199 13 10.5602C13 10.0006 12.5463 9.54688 11.9867 9.54688C11.427 9.54688 10.9733 10.0006 10.9733 10.5602C10.9733 11.1199 11.427 11.5735 11.9867 11.5735Z"
      fill="#AECBFA"
    />
    <path
      d="M11.9867 8.59991C12.5463 8.59991 13 8.14622 13 7.58658C13 7.02693 12.5463 6.57324 11.9867 6.57324C11.427 6.57324 10.9733 7.02693 10.9733 7.58658C10.9733 8.14622 11.427 8.59991 11.9867 8.59991Z"
      fill="#AECBFA"
    />
    <path
      d="M12 16.9735C11.7381 16.9737 11.4862 16.8724 11.2973 16.6909C11.1083 16.5095 10.997 16.2619 10.9867 16.0001V13.4668C10.9867 13.2016 11.0921 12.9472 11.2796 12.7597C11.4671 12.5722 11.7215 12.4668 11.9867 12.4668C12.2519 12.4668 12.5063 12.5722 12.6938 12.7597C12.8813 12.9472 12.9867 13.2016 12.9867 13.4668V16.0001C12.9798 16.2584 12.8733 16.504 12.6893 16.6854C12.5054 16.8669 12.2584 16.9701 12 16.9735Z"
      fill="#AECBFA"
    />
  </svg>
);

export const DSPYSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1148_5989)">
      <path
        d="M1.96742 0.421623C1.1852 0.496042 0.711124 0.64488 0.616309 0.868135C0.379272 1.5379 0.189642 30.6108 0.42668 30.9829C0.592605 31.2309 1.75409 31.3798 4.64594 31.5286C9.88446 31.8511 30.9571 31.7022 31.2652 31.3798C31.4074 31.2309 31.5259 25.7239 31.5733 16.1736C31.6445 2.15806 31.6208 1.19061 31.2415 0.892941C31.0045 0.719297 29.9852 0.496042 28.9896 0.421623C27.1171 0.24798 4.21927 0.272786 1.96742 0.421623ZM15.7867 2.10844C15.8815 2.3317 15.8578 3.10069 15.763 3.84488C15.6208 5.18441 15.5971 5.20922 14.8385 5.20922C11.6148 5.20922 11.5674 11.386 14.7911 11.4852C15.2652 11.51 15.6445 11.6092 15.6445 11.7332C15.6445 11.8325 15.5259 12.7255 15.36 13.6929L15.0993 15.4294L14.0089 15.2805C10.8326 14.8092 10.2874 14.8092 9.86075 15.2557C9.60001 15.5286 9.5052 15.9007 9.57631 16.2232C10.1452 18.2573 9.83705 18.8526 8.29631 18.8526C6.58964 18.8526 6.3052 18.4061 6.92149 16.6201C7.15853 15.8759 7.13483 15.7519 6.63705 15.3301C6.21038 14.9581 5.6889 14.8836 3.84001 14.8836H1.58816L1.73038 12.8247C1.8252 11.7084 1.89631 8.80612 1.89631 6.39992V2.00922L2.56001 1.91C2.91557 1.86038 5.99705 1.78596 9.43409 1.76116C14.7911 1.73635 15.6682 1.78596 15.7867 2.10844ZM30.0326 2.05883C30.1985 2.23248 30.1985 15.3798 30.0326 15.5286C30.0089 15.5534 29.1556 15.6278 28.1363 15.6774L26.2874 15.8015L26.4296 15.2061C26.643 14.2387 26.1215 12.9488 25.363 12.527C24.4859 12.0557 22.5185 12.0557 21.4519 12.5022C20.4326 12.9488 20.0771 13.6681 20.1956 15.0325L20.2667 16.0991L19.2 15.9751C16.6163 15.6774 16.5452 15.6526 16.6874 15.0325C16.7585 14.71 16.9482 13.5937 17.0904 12.5519C17.3274 10.865 17.3274 10.5922 16.9719 10.1953C16.6637 9.82317 16.3556 9.74875 15.6208 9.84798C14.4593 10.0216 13.9852 9.62472 13.9852 8.50844C13.9852 7.04488 14.3171 6.67279 15.5971 6.7472C16.5452 6.82162 16.7111 6.7472 16.9956 6.20147C17.1615 5.85418 17.3037 4.7379 17.3037 3.64643V1.68674L23.5615 1.78596C26.9985 1.81077 29.9141 1.95961 30.0326 2.05883ZM24.4385 13.9162C24.8415 14.1395 24.8889 14.3875 24.8415 15.7022L24.7704 17.2402L27.4963 17.1906L30.2222 17.1658L30.1985 18.679C30.1748 19.5224 30.1511 22.4743 30.1274 25.2278L30.1037 30.2635H23.2296H16.3556V28.527V26.8154L17.5408 26.9643C18.6548 27.0883 18.7496 27.0635 19.5793 26.1953C20.4326 25.3022 20.4326 25.2774 20.3378 23.541C20.2667 21.9534 20.1719 21.7053 19.5556 21.1596C18.963 20.6139 18.7022 20.5395 17.4696 20.6387L16.0711 20.7379L16.2133 20.0185C16.2845 19.6216 16.3556 18.8278 16.3556 18.2325V17.1906L17.4933 17.3891C18.1096 17.4883 19.2711 17.5875 20.0533 17.5875C21.9259 17.6123 22.2104 17.3146 21.8311 15.7519C21.6889 15.1069 21.6178 14.4867 21.7126 14.3627C22.0919 13.7177 23.6563 13.4697 24.4385 13.9162ZM5.09631 17.6371C5.12001 19.1751 5.6889 19.9937 6.92149 20.341C8.34372 20.7627 9.88446 20.4402 10.7141 19.5968C11.2593 19.0263 11.3778 18.679 11.3778 17.7115V16.5457L12.4682 16.7193C13.0845 16.7937 13.8193 16.8681 14.1274 16.8681C14.6963 16.8681 14.6963 16.9177 14.6963 19.3488C14.6963 21.4573 14.7674 21.9038 15.1467 22.3007C15.5971 22.772 15.6682 22.772 16.7822 22.3999C17.4222 22.1767 18.1096 22.0774 18.323 22.1519C18.7971 22.3255 19.0341 23.8387 18.7259 24.6821C18.4889 25.3022 18.3941 25.3519 17.4696 25.2278C16.9245 25.1782 16.3082 25.0294 16.1185 24.955C15.9052 24.8557 15.5496 24.955 15.2889 25.1534C14.8859 25.4511 14.7911 25.8728 14.7437 27.8821L14.6489 30.2635H11.7571C10.1452 30.2635 7.22964 30.1891 5.26224 30.0898L1.65927 29.941V23.1441V16.3472L3.38964 16.4216L5.09631 16.496V17.6371Z"
        fill="#EF4036"
      />
    </g>
    <defs>
      <clipPath id="clip0_1148_5989">
        <rect width="32" height="32" fill="transparent" />
      </clipPath>
    </defs>
  </svg>
);

export const AnthropicSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.2835 6L26.4963 26.5994H31L22.7873 6H18.2835Z"
      fill="currentColor"
    />
    <path
      d="M8.75587 18.4479L11.566 11.2087L14.3762 18.4479H8.75587ZM9.21147 6L1 26.5994H5.59136L7.27074 22.2735H15.8616L17.5407 26.5994H22.132L13.9206 6H9.21147Z"
      fill="currentColor"
    />
  </svg>
);

export const GroqSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.9623 11.0195C16.8877 11.0195 15.208 12.6992 15.208 14.7739C15.208 16.8485 16.8877 18.5282 18.9623 18.5282C21.037 18.5282 22.7167 16.8485 22.7167 14.7739C22.7167 12.6992 21.0332 11.0195 18.9623 11.0195ZM18.9623 17.1208C17.6662 17.1208 16.6154 16.07 16.6154 14.7739C16.6154 13.4777 17.6662 12.4269 18.9623 12.4269C20.2585 12.4269 21.3093 13.4777 21.3093 14.7739C21.3093 16.07 20.2585 17.1208 18.9623 17.1208Z"
      fill="currentColor"
    />
    <path
      d="M13.7781 11.0308C13.6515 11.0155 13.5212 11.0078 13.3908 11.0078C13.3256 11.0078 13.2642 11.0078 13.2029 11.0078C13.1415 11.0078 13.0763 11.0155 13.015 11.0193C12.7619 11.0385 12.5126 11.0807 12.2672 11.1459C11.7648 11.2801 11.2969 11.514 10.8904 11.84C10.4763 12.1736 10.1426 12.5954 9.91639 13.0786C9.80518 13.3202 9.72081 13.5733 9.67096 13.8341C9.64411 13.9607 9.62494 14.091 9.61343 14.2214C9.6096 14.2866 9.60193 14.348 9.60193 14.417V14.5129V14.6011V15.8589L9.6096 17.1167L9.61727 18.3746H11.0247L11.0323 17.1167V15.8589L11.04 14.6011V14.4707C11.04 14.4323 11.0477 14.3902 11.0515 14.3518C11.0592 14.2751 11.0707 14.1946 11.086 14.1179C11.1167 13.9683 11.1666 13.8188 11.2317 13.6807C11.3621 13.4008 11.5539 13.1553 11.7955 12.9598C12.0486 12.7603 12.3362 12.6108 12.6468 12.5264C12.8079 12.4842 12.9689 12.4536 13.1377 12.4382C13.1798 12.4382 13.222 12.4305 13.2642 12.4305C13.3064 12.4305 13.3486 12.4305 13.3908 12.4305C13.4713 12.4305 13.5518 12.4344 13.6324 12.442C13.9545 12.4727 14.2651 12.5724 14.5451 12.7297L15.2468 11.5102C14.7982 11.2494 14.2996 11.0845 13.7858 11.027L13.7781 11.0308Z"
      fill="currentColor"
    />
    <path
      d="M4.789 11.0002C2.71434 10.981 1.01934 12.6453 1.00016 14.72C0.98099 16.7946 2.64532 18.4896 4.71997 18.5088H6.02383V17.1014H4.789C3.49282 17.1168 2.43057 16.0775 2.41523 14.7813C2.39989 13.4852 3.43913 12.4229 4.73531 12.4076H4.789C6.08518 12.4076 7.13593 13.4583 7.13977 14.7545V18.2135C7.13977 19.4982 6.09285 20.5451 4.81201 20.5605C4.19843 20.5566 3.6117 20.3074 3.17836 19.874L2.1813 20.8711C2.87157 21.5652 3.80728 21.9602 4.78517 21.9717H4.83502C6.88283 21.941 8.52799 20.2805 8.53949 18.2327V14.6663C8.48964 12.6261 6.82531 11.0002 4.789 11.0002Z"
      fill="currentColor"
    />
    <path
      d="M27.2533 11.0195C25.1787 11.0195 23.499 12.6992 23.499 14.7739C23.499 16.8485 25.1787 18.5282 27.2533 18.5282H28.538V17.1208H27.2533C25.9572 17.1208 24.9064 16.07 24.9064 14.7739C24.9064 13.4777 25.9572 12.4269 27.2533 12.4269C28.469 12.4269 29.4852 13.3588 29.5926 14.5706V21.7801H31V14.7739C30.9962 12.703 29.3242 11.0195 27.2533 11.0195Z"
      fill="currentColor"
    />
  </svg>
);

export const CrewAISVG = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="32"
    height="32"
    viewBox="0 0 400 400"
    enableBackground="new 0 0 400 400"
    xmlSpace="preserve"
  >
    <path
      fill="currentColor"
      stroke="none"
      d="
M108.357758,374.748016
	C68.931068,356.066071 45.775341,325.019348 36.873970,283.154297
	C30.389435,252.656082 33.336266,222.467133 42.685719,193.016541
	C58.768898,142.354813 85.827126,98.280418 124.748680,61.938580
	C145.764755,42.315449 169.544373,26.902735 197.551865,18.696321
	C233.877899,8.052515 266.357330,15.785578 295.642151,38.813885
	C311.787628,51.509991 325.734741,66.145889 333.571045,85.621201
	C340.671906,103.268669 340.516388,121.362411 336.592682,139.643417
	C333.681305,153.207916 328.341309,165.942825 322.998566,178.398621
	C323.824585,180.318497 325.412994,180.144730 326.588379,180.303497
	C348.189026,183.221146 362.405640,201.825790 365.324188,224.059479
	C369.047516,252.424057 359.334717,276.863831 342.760071,298.986633
	C309.078064,343.943359 264.191742,371.643372 209.528900,383.468353
	C175.162979,390.902557 141.349426,389.043335 108.357758,374.748016
M271.080261,209.564880
	C276.822632,194.262497 283.971436,179.601944 291.199829,164.964279
	C296.215637,154.807129 300.561798,144.335480 303.180573,133.260727
	C307.179047,116.351280 306.355347,100.337906 294.874695,86.023811
	C283.959991,72.415321 271.036224,61.444416 255.257523,53.889622
	C243.448471,48.235489 231.098053,46.722847 218.275681,48.963493
	C190.663696,53.788551 168.189636,68.463501 148.031158,86.866074
	C121.336411,111.235603 101.638069,140.797668 86.485901,173.465500
	C72.204773,204.255356 64.520126,236.334229 69.392883,270.412170
	C73.207108,297.087158 84.966972,319.501312 107.685608,335.065063
	C135.185516,353.904266 165.862350,356.662231 197.639496,351.232513
	C226.848587,346.241608 253.160049,333.984497 277.058044,316.581299
	C297.531555,301.671906 314.873077,283.874969 325.936218,260.777405
	C331.523773,249.111649 333.769897,236.736618 330.307495,223.889450
	C329.156708,219.619415 327.376648,215.425262 322.397522,214.499054
	C317.326202,213.555649 314.021484,216.935379 310.871582,220.215073
	C310.074585,221.044922 309.510468,222.103455 308.867737,223.075668
	C300.009247,236.475174 289.673126,248.552429 277.708557,259.333801
	C249.653473,284.614502 216.635345,296.440063 179.132095,296.318329
	C161.393463,296.260742 149.833130,287.682251 145.810806,270.539856
	C140.823715,249.285797 142.451172,227.976303 150.218277,207.764145
	C164.287735,171.151611 185.422729,138.726166 211.975861,109.887596
	C218.737091,102.544426 225.840866,95.432785 234.904358,90.815033
	C237.647705,89.417328 240.608063,87.398354 243.710663,89.989059
	C247.025345,92.756889 246.760300,96.405632 245.685867,100.093086
	C244.092072,105.562981 241.271606,110.502014 238.899857,115.639061
	C231.912460,130.773315 225.552048,146.141083 222.041946,162.530533
	C217.079269,185.702393 230.538971,209.662094 252.994049,217.609100
	C261.908478,220.763977 266.484222,218.869110 271.080261,209.564880
z"
    />
  </svg>
);
export const NodeJSSVG = () => (
  <svg
    fill="var(--global-text-color-900)"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M 15.994141 3 C 15.629141 3 15.264219 3.0895313 14.949219 3.2695312 L 5.0390625 8.9902344 C 4.3990625 9.3602344 4 10.060781 4 10.800781 L 4 21.179688 C 4 21.929688 4.3990625 22.620234 5.0390625 22.990234 L 7.640625 24.490234 C 8.900625 25.110234 9.3499219 25.109375 9.9199219 25.109375 C 11.789922 25.109375 12.859375 23.979531 12.859375 22.019531 L 12.859375 11.310547 C 12.859375 11.150547 12.730312 11.019531 12.570312 11.019531 L 11.320312 11.019531 C 11.150313 11.019531 11.029297 11.150547 11.029297 11.310547 L 11.029297 22.009766 C 11.029297 22.889766 10.120391 23.749531 8.6503906 23.019531 L 5.9296875 21.449219 C 5.8296875 21.399219 5.7695313 21.289687 5.7695312 21.179688 L 5.7695312 10.810547 C 5.7695312 10.690547 5.8296875 10.589297 5.9296875 10.529297 L 15.839844 4.8105469 C 15.929844 4.7505469 16.050391 4.7505469 16.150391 4.8105469 L 26.060547 10.529297 C 26.160547 10.589297 26.220703 10.690781 26.220703 10.800781 L 26.220703 21.179688 C 26.220703 21.289687 26.160313 21.399219 26.070312 21.449219 L 16.150391 27.179688 C 16.060391 27.229688 15.929844 27.229688 15.839844 27.179688 L 13.289062 25.669922 C 13.219062 25.619922 13.120781 25.610391 13.050781 25.650391 C 12.340781 26.050391 12.210781 26.100078 11.550781 26.330078 C 11.390781 26.380078 11.140625 26.479766 11.640625 26.759766 L 14.949219 28.720703 C 15.269219 28.900703 15.630234 29 15.990234 29 C 16.360234 29 16.719062 28.900703 17.039062 28.720703 L 26.960938 22.990234 C 27.600938 22.620234 28 21.929688 28 21.179688 L 28 10.810547 C 28 10.060547 27.600938 9.37 26.960938 9 L 17.039062 3.2695312 C 16.724063 3.0895313 16.359141 3 15.994141 3 z M 18.660156 11.005859 C 15.830156 11.005859 14.140625 12.205078 14.140625 14.205078 C 14.140625 16.375078 15.819062 16.974141 18.539062 17.244141 C 21.789062 17.564141 22.039062 18.045547 22.039062 18.685547 C 22.039062 19.785547 21.150547 20.255859 19.060547 20.255859 C 16.430547 20.255859 15.850156 19.594922 15.660156 18.294922 C 15.640156 18.154922 15.520859 18.054688 15.380859 18.054688 L 14.089844 18.054688 C 13.929844 18.054688 13.810547 18.185938 13.810547 18.335938 C 13.810547 20.005937 14.720547 21.994141 19.060547 21.994141 C 22.200547 21.994141 24 20.755703 24 18.595703 C 24 16.455703 22.549766 15.884609 19.509766 15.474609 C 16.419766 15.074609 16.109375 14.864531 16.109375 14.144531 C 16.109375 13.544531 16.380156 12.755859 18.660156 12.755859 C 20.690156 12.755859 21.449766 13.194453 21.759766 14.564453 C 21.789766 14.694453 21.899062 14.794922 22.039062 14.794922 L 23.330078 14.794922 C 23.410078 14.794922 23.479063 14.755313 23.539062 14.695312 C 23.589062 14.645313 23.619375 14.564609 23.609375 14.474609 C 23.409375 12.114609 21.840156 11.005859 18.660156 11.005859 z" />
  </svg>
);

export const VercelSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.357 4L26.714 27H4L15.357 4Z" fill="currentColor" />
  </svg>
);

export const BedrockSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 27.2566L11.5523 28.7398L9.81789 27.583L11.7063 26.9523L11.1269 25.2142L7.88552 26.2941L6.83316 25.5937V20.5832C6.83316 20.2366 6.63699 19.9195 6.32715 19.7636L3.16643 18.1833V13.8162L5.91648 12.4412L8.66653 13.8162V16.9164C8.66653 17.2648 8.8627 17.5819 9.17254 17.7378L12.8393 19.5711L13.6606 17.9303L10.4999 16.3499V13.8162L13.6606 12.2377C13.9705 12.0818 14.1666 11.7647 14.1666 11.4163V8.66627H12.3333V10.8498L9.58322 12.2248L6.83316 10.8498V6.40756L8.66653 5.1847V8.66627H10.4999V3.96368L11.5523 3.2615L16 4.74469V27.2566ZM26.0835 25.1666C26.5877 25.1666 27.0002 25.5772 27.0002 26.0833C27.0002 26.5893 26.5877 26.9999 26.0835 26.9999C25.5793 26.9999 25.1668 26.5893 25.1668 26.0833C25.1668 25.5772 25.5793 25.1666 26.0835 25.1666ZM24.2502 4.99953C24.7543 4.99953 25.1668 5.41021 25.1668 5.91621C25.1668 6.42222 24.7543 6.8329 24.2502 6.8329C23.746 6.8329 23.3335 6.42222 23.3335 5.91621C23.3335 5.41021 23.746 4.99953 24.2502 4.99953ZM27.9169 15.9997C28.4211 15.9997 28.8336 16.4104 28.8336 16.9164C28.8336 17.4224 28.4211 17.8331 27.9169 17.8331C27.4127 17.8331 27.0002 17.4224 27.0002 16.9164C27.0002 16.4104 27.4127 15.9997 27.9169 15.9997ZM25.3355 17.8331C25.715 18.8983 26.7234 19.6665 27.9169 19.6665C29.4331 19.6665 30.6669 18.4344 30.6669 16.9164C30.6669 15.4002 29.4331 14.1664 27.9169 14.1664C26.7234 14.1664 25.715 14.9364 25.3355 15.9997H17.8334V12.333H24.2502C24.7562 12.333 25.1668 11.9242 25.1668 11.4163V8.4976C26.232 8.11809 27.0002 7.10974 27.0002 5.91621C27.0002 4.40002 25.7664 3.16616 24.2502 3.16616C22.734 3.16616 21.5001 4.40002 21.5001 5.91621C21.5001 7.10974 22.2683 8.11809 23.3335 8.4976V10.4996H17.8334V4.08285C17.8334 3.68867 17.5804 3.3385 17.2064 3.21383L11.7063 1.38046C11.4367 1.29063 11.1434 1.33096 10.9087 1.4868L5.40864 5.15353C5.1538 5.32404 4.9998 5.61004 4.9998 5.91621V10.8498L1.83907 12.4302C1.52923 12.586 1.33306 12.9032 1.33306 13.2497V18.7498C1.33306 19.0981 1.52923 19.4153 1.83907 19.5711L4.9998 21.1497V26.0833C4.9998 26.3894 5.1538 26.6773 5.40864 26.8459L10.9087 30.5127C11.0609 30.6153 11.2369 30.6667 11.4166 30.6667C11.5138 30.6667 11.6109 30.652 11.7063 30.619L17.2064 28.7856C17.5804 28.6628 17.8334 28.3126 17.8334 27.9166V23.3332H22.0373L23.6011 24.8989L23.625 24.8751C23.4453 25.2417 23.3335 25.6488 23.3335 26.0833C23.3335 27.5995 24.5673 28.8333 26.0835 28.8333C27.5997 28.8333 28.8336 27.5995 28.8336 26.0833C28.8336 24.5671 27.5997 23.3332 26.0835 23.3332C25.6472 23.3332 25.2402 23.445 24.8753 23.6265L24.8992 23.6027L23.0658 21.7693C22.8935 21.597 22.6606 21.4998 22.4168 21.4998H17.8334V17.8331H25.3355Z"
      fill="currentColor"
    />
  </svg>
);

export const HuggingFaceSVG = () => (
  <svg
    width="32"
    height="32"
    style={{ flex: "none", lineHeight: "1" }}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>HuggingFace</title>
    <g fill="none" fillRule="nonzero">
      <path
        d="M2.25 11.535c0-3.407 1.847-6.554 4.844-8.258a9.822 9.822 0 019.687 0c2.997 1.704 4.844 4.851 4.844 8.258 0 5.266-4.337 9.535-9.687 9.535S2.25 16.8 2.25 11.535z"
        fill="#FF9D0B"
      ></path>
      <path
        d="M11.938 20.086c4.797 0 8.687-3.829 8.687-8.551 0-4.722-3.89-8.55-8.687-8.55-4.798 0-8.688 3.828-8.688 8.55 0 4.722 3.89 8.55 8.688 8.55z"
        fill="#FFD21E"
      ></path>
      <path
        d="M11.875 15.113c2.457 0 3.25-2.156 3.25-3.263 0-.576-.393-.394-1.023-.089-.582.283-1.365.675-2.224.675-1.798 0-3.25-1.693-3.25-.586 0 1.107.79 3.263 3.25 3.263h-.003z"
        fill="#FF323D"
      ></path>
      <path
        d="M14.76 9.21c.32.108.445.753.767.585.447-.233.707-.708.659-1.204a1.235 1.235 0 00-.879-1.059 1.262 1.262 0 00-1.33.394c-.322.384-.377.92-.14 1.36.153.283.638-.177.925-.079l-.002.003zm-5.887 0c-.32.108-.448.753-.768.585a1.226 1.226 0 01-.658-1.204c.048-.495.395-.913.878-1.059a1.262 1.262 0 011.33.394c.322.384.377.92.14 1.36-.152.283-.64-.177-.925-.079l.003.003zm1.12 5.34a2.166 2.166 0 011.325-1.106c.07-.02.144.06.219.171l.192.306c.069.1.139.175.209.175.074 0 .15-.074.223-.172l.205-.302c.08-.11.157-.188.234-.165.537.168.986.536 1.25 1.026.932-.724 1.275-1.905 1.275-2.633 0-.508-.306-.426-.81-.19l-.616.296c-.52.24-1.148.48-1.824.48-.676 0-1.302-.24-1.823-.48l-.589-.283c-.52-.248-.838-.342-.838.177 0 .703.32 1.831 1.187 2.56l.18.14z"
        fill="#3A3B45"
      ></path>
      <path
        d="M17.812 10.366a.806.806 0 00.813-.8c0-.441-.364-.8-.813-.8a.806.806 0 00-.812.8c0 .442.364.8.812.8zm-11.624 0a.806.806 0 00.812-.8c0-.441-.364-.8-.812-.8a.806.806 0 00-.813.8c0 .442.364.8.813.8zM4.515 13.073c-.405 0-.765.162-1.017.46a1.455 1.455 0 00-.333.925 1.801 1.801 0 00-.485-.074c-.387 0-.737.146-.985.409a1.41 1.41 0 00-.2 1.722 1.302 1.302 0 00-.447.694c-.06.222-.12.69.2 1.166a1.267 1.267 0 00-.093 1.236c.238.533.81.958 1.89 1.405l.24.096c.768.3 1.473.492 1.478.494.89.243 1.808.375 2.732.394 1.465 0 2.513-.443 3.115-1.314.93-1.342.842-2.575-.274-3.763l-.151-.154c-.692-.684-1.155-1.69-1.25-1.912-.195-.655-.71-1.383-1.562-1.383-.46.007-.889.233-1.15.605-.25-.31-.495-.553-.715-.694a1.87 1.87 0 00-.993-.312zm14.97 0c.405 0 .767.162 1.017.46.216.262.333.588.333.925.158-.047.322-.071.487-.074.388 0 .738.146.985.409a1.41 1.41 0 01.2 1.722c.22.178.377.422.445.694.06.222.12.69-.2 1.166.244.37.279.836.093 1.236-.238.533-.81.958-1.889 1.405l-.239.096c-.77.3-1.475.492-1.48.494-.89.243-1.808.375-2.732.394-1.465 0-2.513-.443-3.115-1.314-.93-1.342-.842-2.575.274-3.763l.151-.154c.695-.684 1.157-1.69 1.252-1.912.195-.655.708-1.383 1.56-1.383.46.007.889.233 1.15.605.25-.31.495-.553.718-.694.244-.162.523-.265.814-.3l.176-.012z"
        fill="#FF9D0B"
      ></path>
      <path
        d="M9.785 20.132c.688-.994.638-1.74-.305-2.667-.945-.928-1.495-2.288-1.495-2.288s-.205-.788-.672-.714c-.468.074-.81 1.25.17 1.971.977.721-.195 1.21-.573.534-.375-.677-1.405-2.416-1.94-2.751-.532-.332-.907-.148-.782.541.125.687 2.357 2.35 2.14 2.707-.218.362-.983-.42-.983-.42S2.953 14.9 2.43 15.46c-.52.558.398 1.026 1.7 1.803 1.308.778 1.41.985 1.225 1.28-.187.295-3.07-2.1-3.34-1.083-.27 1.011 2.943 1.304 2.745 2.006-.2.7-2.265-1.324-2.685-.537-.425.79 2.913 1.718 2.94 1.725 1.075.276 3.813.859 4.77-.522zm4.432 0c-.687-.994-.64-1.74.305-2.667.943-.928 1.493-2.288 1.493-2.288s.205-.788.675-.714c.465.074.807 1.25-.17 1.971-.98.721.195 1.21.57.534.377-.677 1.407-2.416 1.94-2.751.532-.332.91-.148.782.541-.125.687-2.355 2.35-2.137 2.707.215.362.98-.42.98-.42S21.05 14.9 21.57 15.46c.52.558-.395 1.026-1.7 1.803-1.308.778-1.408.985-1.225 1.28.187.295 3.07-2.1 3.34-1.083.27 1.011-2.94 1.304-2.743 2.006.2.7 2.263-1.324 2.685-.537.423.79-2.912 1.718-2.94 1.725-1.077.276-3.815.859-4.77-.522z"
        fill="#FFD21E"
      ></path>
    </g>
  </svg>
);

export const BeeAISVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 27.82 27.83"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icons">
      <g>
        <path d="m16.02,27.83h0c-1.48,0-2.97-.57-4.1-1.7-2.26-2.26-2.26-5.94,0-8.2l9.9-9.9v14c0,1.6-.65,3.05-1.7,4.1h0c-.56.56-1.2.98-1.88,1.26-.68.28-1.43.44-2.22.44Z" />
        <path d="m5.8,17.61c-1.48,0-2.97-.57-4.1-1.7C.57,14.78,0,13.3,0,11.82h0c0-.76.15-1.49.42-2.16.28-.71.71-1.37,1.28-1.94h0c1.05-1.05,2.5-1.7,4.1-1.7h14s-9.9,9.89-9.9,9.89c-1.13,1.13-2.61,1.7-4.1,1.7Z" />
        <path d="m24.41,8.44c-.78-.78-.78-2.05,0-2.83s2.05-.78,2.83,0,.78,2.05,0,2.83-2.05.78-2.83,0Z" />
        <path d="m19.39,3.42c-.78-.78-.78-2.05,0-2.83s2.05-.78,2.83,0,.78,2.05,0,2.83-2.05.78-2.83,0Z" />
      </g>
    </g>
  </svg>
);

export const IntegrationSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2593 6.61905C19.0126 7.16696 18.7815 8.04669 18.5292 9.00706C18.4235 9.40941 18.3141 9.82591 18.1982 10.2381H23.1482C23.7004 10.2381 24.1482 10.6858 24.1482 11.2381V17.0307C24.5195 16.902 24.8948 16.7804 25.2572 16.663C26.122 16.383 26.9141 16.1264 27.4074 15.8525C29.0175 14.9587 30.6667 17.4728 30.6667 19.4716C30.6667 21.4703 29.0371 23.9954 27.4074 23.0906C26.914 22.8166 26.1217 22.56 25.2569 22.2799L25.2568 22.2799C24.8945 22.1625 24.5194 22.041 24.1482 21.9124V27.3333C24.1482 27.8856 23.7004 28.3333 23.1482 28.3333H8.85186C8.29957 28.3333 7.85186 27.8856 7.85186 27.3333V21.9159C7.48052 22.0446 7.10529 22.1662 6.74283 22.2836C5.8781 22.5636 5.086 22.8202 4.59263 23.0941C2.98259 23.9879 1.33337 21.4738 1.33337 19.475C1.33337 17.4763 2.963 14.9511 4.59263 15.856C5.08608 16.13 5.87835 16.3866 6.74324 16.6667C7.10558 16.7841 7.48066 16.9056 7.85186 17.0342V11.2381C7.85186 10.6858 8.29957 10.2381 8.85186 10.2381H13.8018C13.686 9.82578 13.5765 9.40914 13.4708 9.00667L13.4708 9.00661L13.4708 9.00659L13.4707 9.00657L13.4707 9.00656C13.2185 8.04639 12.9875 7.16687 12.7408 6.61905C11.9359 4.83128 14.2 3 16.0001 3C17.8001 3 20.0742 4.80952 19.2593 6.61905ZM12.2564 21.0247C11.9603 21.3049 11.5203 21.259 11.2731 20.9233C11.0258 20.5877 11.0663 20.0881 11.3625 19.8087L15.5529 15.8503C15.5746 15.8294 15.5991 15.8157 15.6237 15.8019C15.6363 15.7949 15.6489 15.7879 15.6611 15.7799C15.6701 15.7739 15.6788 15.7676 15.6874 15.7614C15.7062 15.7477 15.7248 15.7342 15.7464 15.7245C15.8281 15.688 15.9133 15.6667 15.9999 15.6667C16.0865 15.6667 16.1717 15.688 16.2534 15.7245C16.275 15.7342 16.2936 15.7478 16.3124 15.7614C16.321 15.7676 16.3296 15.7739 16.3386 15.7799C16.3509 15.7879 16.3635 15.7949 16.376 15.8019C16.4006 15.8157 16.4251 15.8294 16.4469 15.8503L20.6373 19.8087C20.9341 20.0881 20.9739 20.5877 20.7267 20.9233C20.4801 21.259 20.0402 21.3049 19.7433 21.0247L16.6983 18.1485V28.3333H15.9999H15.1852L15.3015 18.1485L12.2564 21.0247Z"
      fill="var(--global-text-color-900)"
    />
  </svg>
);

export const AgnoSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2815_4632)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7469 1.84196C16.0957 2.52647 16.0957 3.42256 16.0957 5.21473V10.9752C16.0957 12.7674 16.0957 13.6634 15.7469 14.348C15.4401 14.9501 14.9506 15.4396 14.3485 15.7464C13.6639 16.0952 12.7679 16.0952 10.9757 16.0952H5.21522C3.42305 16.0952 2.52696 16.0952 1.84245 15.7464C1.24033 15.4396 0.750789 14.9501 0.443994 14.348C0.0952148 13.6634 0.0952148 12.7674 0.0952148 10.9752V5.21473C0.0952148 3.42256 0.0952148 2.52647 0.443994 1.84196C0.750789 1.23984 1.24033 0.7503 1.84245 0.443506C2.52696 0.0947266 3.42305 0.0947266 5.21521 0.0947266H10.9757C12.7678 0.0947266 13.6639 0.0947266 14.3485 0.443506C14.9506 0.7503 15.4401 1.23984 15.7469 1.84196ZM5.27398 3.77524H9.3046L12.594 12.0905H10.9168L8.32056 5.18973H5.27398V3.77524ZM2.99402 10.676H7.12113V12.0905H2.99402V10.676Z"
        fill="#FF4017"
      />
    </g>
    <defs>
      <clipPath id="clip0_2815_4632">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const McpSVG = () => (
  <svg
    width="32"
    height="32"
    fill="currentColor"
    fillRule="evenodd"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>ModelContextProtocol</title>
    <path d="M15.688 2.343a2.588 2.588 0 00-3.61 0l-9.626 9.44a.863.863 0 01-1.203 0 .823.823 0 010-1.18l9.626-9.44a4.313 4.313 0 016.016 0 4.116 4.116 0 011.204 3.54 4.3 4.3 0 013.609 1.18l.05.05a4.115 4.115 0 010 5.9l-8.706 8.537a.274.274 0 000 .393l1.788 1.754a.823.823 0 010 1.18.863.863 0 01-1.203 0l-1.788-1.753a1.92 1.92 0 010-2.754l8.706-8.538a2.47 2.47 0 000-3.54l-.05-.049a2.588 2.588 0 00-3.607-.003l-7.172 7.034-.002.002-.098.097a.863.863 0 01-1.204 0 .823.823 0 010-1.18l7.273-7.133a2.47 2.47 0 00-.003-3.537z"></path>
    <path d="M14.485 4.703a.823.823 0 000-1.18.863.863 0 00-1.204 0l-7.119 6.982a4.115 4.115 0 000 5.9 4.314 4.314 0 006.016 0l7.12-6.982a.823.823 0 000-1.18.863.863 0 00-1.204 0l-7.119 6.982a2.588 2.588 0 01-3.61 0 2.47 2.47 0 010-3.54l7.12-6.982z"></path>
  </svg>
);

export const GeminiSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Gemini</title>
    <defs>
      <linearGradient
        id="lobe-icons-gemini-fill"
        x1="0%"
        x2="68.73%"
        y1="100%"
        y2="30.395%"
      >
        <stop offset="0%" stopColor="#1C7DFF"></stop>
        <stop offset="52.021%" stopColor="#1C69FF"></stop>
        <stop offset="100%" stopColor="#F0DCD6"></stop>
      </linearGradient>
    </defs>
    <path
      d="M12 24A14.304 14.304 0 000 12 14.304 14.304 0 0012 0a14.305 14.305 0 0012 12 14.305 14.305 0 00-12 12"
      fill="url(#lobe-icons-gemini-fill)"
      fillRule="nonzero"
    ></path>
  </svg>
);

export const PydanticAISVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 115 115"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="#FFBDDB"
      d="M62.3737 105.707C59.5781 109.547 53.8509 109.547 51.0553 105.707L27.7796 73.7344C25.0105 69.9307 26.7073 64.5329 31.1546 62.9977L54.4303 54.9628C55.9102 54.4519 57.5187 54.4519 58.9987 54.9628L82.2744 62.9977C86.7217 64.533 88.4184 69.9307 85.6494 73.7344L62.3737 105.707ZM56.7145 99.8879L78.3862 70.1187L56.7145 62.6375L35.0428 70.1187L56.7145 99.8879Z"
    />
    <path
      fill="#FFBDDB"
      d="M110.86 62.2624C113.648 66.1079 111.878 71.5547 107.362 73.0268L69.7621 85.2833C65.2889 86.7414 60.6796 83.4597 60.5938 78.7556L60.1447 54.1362C60.1162 52.5708 60.6132 51.0411 61.5564 49.7914L76.3907 30.1379C79.2251 26.3826 84.883 26.4369 87.6448 30.2459L110.86 62.2624ZM103.577 65.8465L81.9617 36.0363L68.1497 54.3355L68.5678 77.2583L103.577 65.8465Z"
    />
    <path
      fill="#FFBDDB"
      d="M84.5326 2.75877C89.0515 1.29523 93.6849 4.66159 93.6894 9.41158L93.7269 48.9589C93.7314 53.6638 89.1859 57.0333 84.6856 55.6613L61.1323 48.4806C59.6347 48.024 58.3334 47.0786 57.4364 45.7954L43.3288 25.6139C40.6333 21.7577 42.4333 16.3935 46.9092 14.9439L84.5326 2.75877ZM85.6907 10.7928L50.6601 22.1382L63.7955 40.929L85.7256 47.6148L85.6907 10.7928Z"
    />
    <path
      fill="#FFBDDB"
      d="M28.9346 2.77586C24.4156 1.31232 19.7823 4.67868 19.7778 9.42867L19.7402 48.976C19.7358 53.6809 24.2812 57.0504 28.7816 55.6784L52.3348 48.4977C53.8324 48.0411 55.1337 47.0957 56.0307 45.8125L70.1383 25.6309C72.8339 21.7748 71.0339 16.4106 66.5579 14.961L28.9346 2.77586ZM27.7765 10.8099L62.8071 22.1553L49.6717 40.9461L27.7415 47.6319L27.7765 10.8099Z"
    />
    <path
      fill="#FFBDDB"
      d="M2.58066 62.2555C-0.20768 66.101 1.56213 71.5479 6.07825 73.02L43.6784 85.2765C48.1516 86.7346 52.7608 83.4529 52.8467 78.7488L53.2958 54.1294C53.3243 52.564 52.8273 51.0342 51.8841 49.7846L37.0498 30.131C34.2154 26.3758 28.5575 26.4301 25.7956 30.239L2.58066 62.2555ZM9.8636 65.8396L31.4788 36.0294L45.2908 54.3286L44.8726 77.2515L9.8636 65.8396Z"
    />
    <path
      fill="white"
      d="M79.5687 82.0867L85.6488 73.7348C86.1993 72.9787 86.5733 72.1596 86.7842 71.3204L74.626 75.2836L67.1038 85.6164C67.9705 85.6767 68.8689 85.5745 69.7619 85.2835L79.5687 82.0867Z"
    />
    <path
      fill="white"
      d="M60.167 55.3667L60.3224 63.8836L68.3744 66.6632L68.219 58.1463L60.167 55.3667Z"
    />
    <path
      fill="white"
      d="M93.7166 38.62L87.6446 30.2459C87.0975 29.4914 86.4368 28.8842 85.7069 28.4248L85.7191 41.2186L93.2279 51.5742C93.5492 50.7726 93.7273 49.8919 93.7264 48.9587L93.7166 38.62Z"
    />
    <path
      fill="white"
      d="M70.4293 51.3149L62.2812 48.8308L67.413 42.0318L75.5611 44.5159L70.4293 51.3149Z"
    />
    <path
      fill="white"
      d="M56.7395 44.7982L61.6199 37.8166L56.7395 30.8349L51.859 37.8166L56.7395 44.7982Z"
    />
    <path
      fill="white"
      d="M44.5547 16.2438C45.2222 15.6823 46.012 15.2344 46.9092 14.9438L56.7071 11.7705L66.5577 14.9608C67.4418 15.2472 68.2215 15.6862 68.8828 16.2363L56.7071 20.1796L44.5547 16.2438Z"
    />
    <path
      fill="white"
      d="M51.1787 48.8499L46.0469 42.0509L37.8988 44.535L43.0306 51.334L51.1787 48.8499Z"
    />
    <path
      fill="white"
      d="M20.2233 51.5523L27.7476 41.1752L27.7598 28.4014C27.0194 28.8627 26.3494 29.4754 25.7957 30.239L19.7501 38.5767L19.7402 48.9757C19.7394 49.8938 19.9118 50.7611 20.2233 51.5523Z"
    />
    <path
      fill="white"
      d="M53.2727 55.3623L45.2207 58.1419L45.0653 66.6588L53.1174 63.8792L53.2727 55.3623Z"
    />
    <path
      fill="white"
      d="M46.3199 85.6104L38.7916 75.2693L26.6406 71.3084C26.8511 72.1518 27.226 72.9749 27.779 73.7346L33.8488 82.0724L43.6778 85.2763C44.5653 85.5656 45.4581 85.6683 46.3199 85.6104Z"
    />
  </svg>
);

export const GoogleADKSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_756_3354)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.69139 10.1458C8.89799 10.3937 8.8645 10.7622 8.61657 10.9688L7.07351 12.2547L8.61657 13.5406C8.8645 13.7472 8.89799 14.1157 8.69139 14.3636C8.48478 14.6115 8.11631 14.645 7.86838 14.4384L5.82029 12.7317C5.52243 12.4834 5.52242 12.026 5.82029 11.7777L7.86838 10.071C8.11631 9.86438 8.48478 9.89788 8.69139 10.1458Z"
        fill="#EA4335"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4459 10.1458C11.2393 10.3937 11.2728 10.7622 11.5207 10.9688L13.0638 12.2547L11.5207 13.5406C11.2728 13.7472 11.2393 14.1157 11.4459 14.3636C11.6525 14.6115 12.021 14.645 12.2689 14.4384L14.317 12.7317C14.6149 12.4834 14.6149 12.026 14.317 11.7777L12.2689 10.071C12.021 9.86438 11.6525 9.89788 11.4459 10.1458Z"
        fill="#EA4335"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.94165 2.19288C4.44903 2.19288 3.23902 3.40289 3.23902 4.89551C3.23902 6.38813 4.44903 7.59814 5.94165 7.59814H8.60776V8.76685H5.94165C3.80357 8.76685 2.07031 7.03359 2.07031 4.89551C2.07031 2.75743 3.80357 1.02417 5.94165 1.02417H9.73995C10.0627 1.02417 10.3243 1.28579 10.3243 1.60852C10.3243 1.93125 10.0627 2.19288 9.73995 2.19288H5.94165Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6895 2.19288C12.1821 2.19288 13.3922 3.40289 13.3922 4.89551C13.3922 6.38813 12.1821 7.59814 10.6895 7.59814H6.89123C6.5685 7.59814 6.30687 7.85977 6.30687 8.1825C6.30687 8.50523 6.5685 8.76685 6.89123 8.76685H10.6895C12.8276 8.76685 14.5609 7.03359 14.5609 4.89551C14.5609 2.75743 12.8276 1.02417 10.6895 1.02417H6.89123C6.5685 1.02417 6.30687 1.28579 6.30687 1.60852C6.30687 1.93125 6.5685 2.19288 6.89123 2.19288H10.6895Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.23902 10.739H4.18859C4.51132 10.739 4.77295 10.4774 4.77295 10.1547C4.77295 9.83196 4.51132 9.57033 4.18859 9.57033H3.01989C2.49545 9.57033 2.07031 9.99547 2.07031 10.5199V14.026C2.07031 14.5505 2.49545 14.9756 3.01989 14.9756H4.18859C4.51132 14.9756 4.77295 14.714 4.77295 14.3912C4.77295 14.0685 4.51132 13.8069 4.18859 13.8069H3.23902V10.739Z"
        fill="#FBBC04"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9452 8.1825C10.9452 7.85977 10.6836 7.59814 10.3608 7.59814H6.89123C6.5685 7.59814 6.30687 7.85977 6.30687 8.1825C6.30687 8.50523 6.5685 8.76685 6.89123 8.76685H10.3608C10.6836 8.76685 10.9452 8.50523 10.9452 8.1825Z"
        fill="#4285F4"
      />
      <path
        d="M6.74514 4.89551C6.74514 5.25858 6.45081 5.55291 6.08774 5.55291C5.72467 5.55291 5.43034 5.25858 5.43034 4.89551C5.43034 4.53244 5.72467 4.23811 6.08774 4.23811C6.45081 4.23811 6.74514 4.53244 6.74514 4.89551Z"
        fill="#4285F4"
      />
      <path
        d="M11.2739 4.89551C11.2739 5.25858 10.9795 5.55291 10.6165 5.55291C10.2534 5.55291 9.95908 5.25858 9.95908 4.89551C9.95908 4.53244 10.2534 4.23811 10.6165 4.23811C10.9795 4.23811 11.2739 4.53244 11.2739 4.89551Z"
        fill="#4285F4"
      />
    </g>
    <defs>
      <clipPath id="clip0_756_3354">
        <rect
          width="12.6294"
          height="14"
          fill="white"
          transform="translate(2 1)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const MastraSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.97078 16.8874C8.76643 16.8874 9.52949 17.2035 10.0921 17.7661C10.6547 18.3287 10.9708 19.0917 10.9708 19.8874C10.9708 20.683 10.6547 21.4461 10.0921 22.0087C9.52949 22.5713 8.76643 22.8874 7.97078 22.8874C7.17513 22.8874 6.41207 22.5713 5.84946 22.0087C5.28685 21.4461 4.97078 20.683 4.97078 19.8874C4.97078 19.0917 5.28685 18.3287 5.84946 17.7661C6.41207 17.2035 7.17513 16.8874 7.97078 16.8874ZM11.9041 9.08738C12.3554 9.08613 12.8012 9.18672 13.2083 9.38166C13.6153 9.5766 13.9731 9.86087 14.2551 10.2133C14.537 10.5657 14.7358 10.9772 14.8366 11.4171C14.9375 11.857 14.9377 12.314 14.8374 12.7541C14.6374 13.6874 14.4374 14.754 14.9708 15.554L15.8374 16.754L16.0374 16.8874C16.1263 16.8874 16.193 16.8429 16.2374 16.754L17.1041 15.4874C17.6374 14.7541 17.4374 13.6874 17.2374 12.8207C17.1437 12.3833 17.1489 11.9305 17.2527 11.4953C17.3566 11.0602 17.5564 10.6538 17.8377 10.3059C18.1189 9.95798 18.4744 9.67737 18.878 9.4846C19.2817 9.29183 19.7234 9.19178 20.1708 9.19178C20.6181 9.19178 21.0598 9.29183 21.4635 9.4846C21.8672 9.67737 22.2227 9.95798 22.5039 10.3059C22.7851 10.6538 22.985 11.0602 23.0888 11.4953C23.1927 11.9305 23.1979 12.3833 23.1041 12.8207C22.9041 13.6874 22.7041 14.6874 23.1041 15.4874L23.9708 16.8207C24.5951 16.8085 25.2077 16.9915 25.7231 17.3441C26.2385 17.6967 26.6311 18.2014 26.846 18.7877C27.0609 19.374 27.0875 20.0128 26.922 20.6149C26.7566 21.2171 26.4074 21.7526 25.923 22.1468C25.4387 22.541 24.8435 22.7743 24.2203 22.8141C23.5971 22.8538 22.977 22.6981 22.4465 22.3687C21.916 22.0392 21.5015 21.5524 21.2609 20.9762C21.0203 20.3999 20.9655 19.7629 21.1041 19.154C21.3041 18.2874 21.5041 17.2874 21.1041 16.4874L20.3041 15.154H20.1708L19.3041 16.4207C18.7708 17.2207 18.9708 18.2874 19.1708 19.2207C19.2739 19.6557 19.2785 20.1083 19.1842 20.5452C19.0899 20.9822 18.8992 21.3926 18.6259 21.7464C18.3526 22.1002 18.0037 22.3885 17.6048 22.5901C17.2058 22.7918 16.7668 22.9017 16.3198 22.9118C15.8729 22.922 15.4293 22.8321 15.0216 22.6488C14.6139 22.4655 14.2522 22.1934 13.9632 21.8524C13.6741 21.5114 13.4649 21.1101 13.3509 20.6778C13.2369 20.2456 13.2209 19.7933 13.3041 19.354C13.5263 18.4652 13.4374 17.6207 13.0374 16.8207L12.4374 15.954C12.0374 15.4652 11.5041 15.1096 10.8374 14.8874C10.1843 14.6362 9.6396 14.1646 9.29747 13.5542C8.95534 12.9438 8.83735 12.2329 8.96391 11.5447C9.09048 10.8565 9.45364 10.2342 9.99056 9.78547C10.5275 9.33673 11.2044 9.08979 11.9041 9.08738Z"
      fill="currentColor"
    />
  </svg>
);

export const ClaudeSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#claude_path)">
      <path
        d="M6.23896 21.3391L12.4972 17.8277L12.6024 17.5227L12.4972 17.353H12.1922L11.1463 17.2886L7.5705 17.192L4.46929 17.0631L1.46473 16.902L0.708756 16.7409L3.05176e-05 15.8067L0.0730515 15.3407L0.708756 14.9133L1.61936 14.9928L3.63171 15.1302L6.65131 15.3385L8.84191 15.4674L12.087 15.8046H12.6024L12.6755 15.5962L12.4994 15.4674L12.3619 15.3385L9.23708 13.2209L5.85453 10.9831L4.08272 9.69451L3.12486 9.04162L2.64164 8.42954L2.43332 7.0937L3.30312 6.13585L4.47144 6.21531L4.76996 6.29477L5.95332 7.20538L8.4811 9.16189L11.782 11.593L12.2653 11.9946L12.4586 11.8572L12.4822 11.7605L12.2653 11.3976L10.4698 8.1525L8.55412 4.85155L7.70151 3.4835L7.476 2.6631C7.39654 2.32591 7.33855 2.04243 7.33855 1.69665L8.32862 0.352224L8.87627 0.176117L10.1971 0.352224L10.7533 0.835446L11.5737 2.71249L12.9031 5.66766L14.9649 9.68591L15.5684 10.8779L15.8905 11.9818L16.0108 12.3189H16.2191V12.1257L16.3888 9.86202L16.7023 7.08296L17.0073 3.50712L17.1125 2.49988L17.6108 1.29289L18.6008 0.64001L19.374 1.0094L20.0097 1.92001L19.9216 2.50846L19.5437 4.96538L18.8027 8.81397L18.3195 11.3911H18.6008L18.923 11.069L20.2266 9.338L22.4172 6.59974L23.3837 5.51303L24.5112 4.31249L25.2349 3.74122H26.603L27.6102 5.23813L27.1592 6.78444L25.7504 8.57128L24.582 10.0854L22.9069 12.3404L21.861 14.1444L21.9576 14.2883L22.2067 14.2647L25.9909 13.4593L28.0355 13.0899L30.4752 12.6711L31.5791 13.1866L31.6994 13.7106L31.2655 14.7823L28.6561 15.4266L25.5957 16.0387L21.0384 17.1168L20.9826 17.1576L21.047 17.2371L23.1002 17.4303L23.9786 17.4776H26.1284L30.1316 17.7761L31.1775 18.4677L31.8046 19.3138L31.6994 19.9581L30.0886 20.7785L27.9152 20.2631L22.8424 19.0561L21.1029 18.6223H20.8623V18.7662L22.312 20.1836L24.9686 22.5826L28.2953 25.6752L28.465 26.4397L28.0376 27.0432L27.5866 26.9788L24.6637 24.7796L23.5361 23.7895L20.9826 21.6397H20.8129V21.8652L21.4014 22.7265L24.509 27.3976L24.6701 28.8301L24.4446 29.2961L23.6392 29.5775L22.7544 29.4164L20.9353 26.8628L19.0583 23.9871L17.5442 21.4099L17.3595 21.5152L16.4661 31.1388L16.0473 31.6306L15.0808 32L14.2755 31.3879L13.8481 30.3979L14.2755 28.4414L14.7909 25.8878L15.2097 23.8583L15.5877 21.3369L15.8132 20.4993L15.7982 20.4435L15.6135 20.4671L13.7128 23.0765L10.822 26.9831L8.5348 29.4314L7.98714 29.6483L7.03788 29.1565L7.12594 28.2781L7.65641 27.4964L10.822 23.4695L12.7313 20.974L13.9641 19.5329L13.9555 19.3246H13.8824L5.47439 24.7839L3.97748 24.9772L3.33319 24.3737L3.41265 23.3836L3.71761 23.0615L6.2454 21.3219L6.23681 21.3305L6.23896 21.3391Z"
        fill="#D97757"
      />
    </g>
    <defs>
      <clipPath id="claude_path">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// Via brand docs https://portkey.ai/
export const PortkeySVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>portkey</title>
    <path
      d="M19.4156 4C21.6857 4 23.7725 5.2273 24.9083 7.20215L28.4588 13.3743L28.512 13.4686C29.6114 15.4561 29.599 17.889 28.4724 19.8669L24.9127 26.1141C23.7803 28.102 21.6862 29.3393 19.4064 29.3393H12.5283C10.2323 29.3393 8.12551 28.0846 6.99914 26.0744L3.49925 19.8271C2.38483 17.8382 2.38926 15.3984 3.51183 13.4141L7.00361 7.24192C8.1335 5.24465 10.2326 4.00001 12.5191 4H19.4156ZM12.5191 7.15583C11.384 7.15583 10.3212 7.77344 9.74135 8.79846L6.24957 14.9706C5.67115 15.9932 5.66866 17.2558 6.24286 18.2809L9.74377 24.5293L9.77115 24.5775C10.3552 25.5805 11.4063 26.1834 12.5283 26.1834H19.4064C20.5382 26.1834 21.5985 25.5696 22.1795 24.5496L25.7382 18.3023C26.3282 17.2665 26.3256 15.9835 25.7314 14.9504L22.1819 8.77727C21.5993 7.76421 20.5427 7.15583 19.4156 7.15583H12.5191ZM16.4262 10.5514C17.0816 10.0078 18.0535 10.0849 18.6154 10.7313L22.4809 15.1782L22.5152 15.2185C23.2239 16.0729 23.2124 17.3194 22.4809 18.1611L18.6154 22.608C18.0535 23.2543 17.0816 23.3316 16.4262 22.7879L16.3952 22.7615C15.7398 22.189 15.672 21.1917 16.243 20.5349L19.6031 16.6697L16.243 12.8044C15.672 12.1476 15.7398 11.1502 16.3952 10.5777L16.4262 10.5514Z"
      fill="url(#paint0_linear_836_902)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_836_902"
        x1="-11.5403"
        y1="10.8627"
        x2="32.4989"
        y2="36.1332"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.173094" stopColor="#00A3FF" />
        <stop offset="0.899073" stopColor="#FF0F00" />
      </linearGradient>
    </defs>
  </svg>
);

// Custom
export const LiteLLMSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>LiteLLM</title>
    <path
      d="M4.59201 23.5378H30.1541V5.76001H19.6138C17.2563 5.76001 14.9954 6.69652 13.3284 8.36351L2.70639 18.9855C1.02649 20.6654 2.21626 23.5378 4.59201 23.5378Z"
      fill="#D8D8D8"
    />
    <path
      d="M30.154 5.76001V14.649L7.043 14.6488L13.3284 8.36355C14.9954 6.69656 17.2564 5.76001 19.6138 5.76001H30.154Z"
      fill="#E8E8E8"
    />
    <path
      d="M5.97632 23.5378H4.59194C2.21628 23.5378 1.02654 20.6654 2.70632 18.9855L5.97632 15.7155V23.5378Z"
      fill="#309CFF"
    />
    <path
      d="M25.9479 7.53775C26.6321 7.53776 27.0598 8.2785 26.7176 8.87108L24.7931 12.2044C24.5549 12.6169 24.1148 12.8711 23.6385 12.8711H8.82077L13.3285 8.36338C13.6278 8.0641 13.9465 7.78875 14.2812 7.53775H25.9479Z"
      fill="#309CFF"
    />
    <path
      d="M29.6919 20.9066C29.8496 20.9066 30.004 20.9204 30.1542 20.9466V26.1998C30.004 26.226 29.8496 26.24 29.6919 26.24C28.6402 26.24 27.7312 25.631 27.2971 24.7466H24.62C24.1859 25.631 23.2769 26.24 22.2252 26.24C20.7525 26.24 19.5586 25.0461 19.5586 23.5733C19.5586 22.1006 20.7525 20.9066 22.2252 20.9066C23.6623 20.9066 24.8336 22.0433 24.8896 23.4666H27.0275C27.0835 22.0433 28.2549 20.9066 29.6919 20.9066Z"
      fill="#6F6F6F"
    />
    <path
      d="M12.9667 20.9066H21.3719L18.3852 26.24H7.82523L9.89099 22.6783C10.527 21.5817 11.6989 20.9066 12.9667 20.9066Z"
      fill="#309CFF"
    />
    <path
      d="M23.9319 8.74667C24.2265 8.74667 24.4652 8.98546 24.4652 9.28001C24.4652 9.57456 24.2265 9.81334 23.9319 9.81334H14.9719C14.6773 9.81334 14.4386 9.57456 14.4386 9.28001C14.4386 8.98546 14.6773 8.74667 14.9719 8.74667H23.9319Z"
      fill="#BCE0FF"
    />
    <path
      d="M28.8386 15.7867C29.1331 15.7867 29.3719 16.0254 29.3719 16.32C29.3719 16.6145 29.1331 16.8533 28.8386 16.8533H8.35856C8.06401 16.8533 7.82523 16.6145 7.82523 16.32C7.82523 16.0254 8.06401 15.7867 8.35856 15.7867H28.8386Z"
      fill="white"
    />
    <path
      d="M21.2652 20.9066L22.5452 20.9066L19.5586 26.24H18.2786L21.2652 20.9066Z"
      fill="white"
    />
    <path
      d="M30.7941 5.12036V26.7375L30.2648 26.8303C30.0792 26.8628 29.8871 26.8801 29.6916 26.8801C28.5346 26.88 27.5191 26.2847 26.9289 25.387H24.9884C24.3981 26.2848 23.3819 26.8801 22.2248 26.8801C21.4999 26.88 20.8296 26.6464 20.2853 26.2512L20.1174 26.553L19.9338 26.8801H6.71404L7.27165 25.9192L8.28142 24.178H4.59196C1.64614 24.1779 0.171022 20.6155 2.25407 18.5325L12.8761 7.91138C14.6631 6.12445 17.0863 5.12045 19.6134 5.12036H30.7941Z"
      stroke="white"
      strokeWidth="1.28"
    />
  </svg>
);

export const AutogenSVG = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M30,1.7778 C31.1045,1.7778 32,2.6776 32,3.7865 L32,28.2135 C32,29.3225 31.1045,30.2222 30,30.2222 L2,30.2222 C0.8954,30.2222 0,29.3225 0,28.2135 L0,3.7865 C0,2.6776 0.8954,1.7778 2,1.7778 L30,1.7778 M21.3593,9.2674 C20.646,9.2674 19.998,9.3915 19.4149,9.6372 C18.8316,9.8829 18.3282,10.2412 17.9063,10.7118 C17.4846,11.1823 17.1596,11.7598 16.9306,12.4444 C16.7066,13.1294 16.5937,13.9115 16.5937,14.7899 L16.5937,15.5035 C16.5938,16.3818 16.7101,17.1641 16.9444,17.8489 C17.1788,18.5285 17.5122,19.1042 17.9445,19.5746 C18.3817,20.045 18.9033,20.4018 19.507,20.6476 C20.1111,20.8882 20.7813,21.0087 21.5156,21.0087 C22.3433,21.0087 23.0487,20.9207 23.632,20.7431 C24.2151,20.5653 24.6928,20.3534 25.0626,20.1076 C25.4318,19.8569 25.7049,19.6238 25.882,19.4098 L25.882,14.8837 L21.3993,14.8837 L21.3993,16.5625 L23.5399,16.5625 L23.5399,18.5851 C23.4567,18.6686 23.3365,18.7584 23.1806,18.8524 C23.0295,18.9413 22.8281,19.0171 22.5781,19.0798 C22.3333,19.1426 22.026,19.1737 21.6562,19.1737 C21.2139,19.1737 20.8261,19.0958 20.493,18.9392 C20.16,18.7826 19.8784,18.5493 19.6492,18.2412 C19.4254,17.9276 19.2551,17.5417 19.1406,17.0868 C19.0261,16.6269 18.9687,16.0992 18.9687,15.5035 L18.9687,14.7743 C18.9687,14.173 19.0226,13.6441 19.1319,13.1892 C19.2412,12.7346 19.4012,12.3535 19.6094,12.0451 C19.8176,11.7367 20.0731,11.5041 20.3749,11.3472 C20.6823,11.1851 21.0313,11.1024 21.4219,11.1024 C21.8958,11.1024 22.2812,11.1851 22.5781,11.3472 C22.88,11.5093 23.1129,11.7334 23.2743,12.0208 C23.4357,12.3084 23.5451,12.6462 23.6025,13.033 L25.875,13.033 C25.7968,12.301 25.5884,11.6515 25.25,11.0868 C24.9166,10.5172 24.4322,10.0723 23.7968,9.7535 C23.1616,9.4294 22.3488,9.2674 21.3593,9.2674 M9.5243,9.4323 L5.2969,20.8524 L7.7899,20.8524 L8.5764,18.4444 L12.6649,18.4444 L13.4531,20.8524 L15.9531,20.8524 L11.7031,9.4323 L9.5243,9.4323 M12.0608,16.6007 L9.1788,16.6007 L10.6163,12.1945 L12.0608,16.6007"
      fill="currentColor"
    />
  </svg>
);

export const BasetenSVG = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.6704,8.5333 L21.3312,8.5333 L21.3312,13.5111 L10.9973,13.5111 C10.9547,13.5102 10.9123,13.5177 10.8726,13.5329 C10.8329,13.5481 10.7967,13.5709 10.7662,13.5998 C10.7356,13.6288 10.7113,13.6633 10.6945,13.7015 C10.6778,13.7397 10.6691,13.7807 10.6688,13.8222 L10.6688,18.1776 C10.6688,18.355 10.8181,18.4887 10.9973,18.4887 L21.3312,18.4887 L21.3312,23.4665 L16.3328,23.4665 C16.2901,23.4656 16.2477,23.4731 16.2081,23.4884 C16.1684,23.5036 16.1322,23.5264 16.1016,23.5552 C16.0711,23.5842 16.0467,23.6188 16.03,23.6569 C16.0133,23.6951 16.0045,23.7362 16.0043,23.7776 L16.0043,28.1332 C16.0043,28.3104 16.1547,28.4443 16.3328,28.4443 L21.0027,28.4443 C21.0455,28.4459 21.0882,28.4389 21.1282,28.4238 C21.1684,28.4089 21.2048,28.3861 21.2354,28.3572 C21.2661,28.328 21.2905,28.2932 21.307,28.2546 C21.3234,28.2162 21.3317,28.1748 21.3312,28.1332 L21.3312,23.4665 L26.3381,23.4665 C26.3808,23.4674 26.4231,23.4599 26.4629,23.4446 C26.5026,23.4295 26.5387,23.4068 26.5692,23.3778 C26.5998,23.3488 26.6242,23.3143 26.6409,23.2761 C26.6576,23.2379 26.6663,23.1968 26.6667,23.1554 L26.6667,18.7998 C26.6667,18.6226 26.5173,18.4887 26.3381,18.4887 L21.3312,18.4887 L21.3312,13.5111 L26.3381,13.5111 C26.3808,13.5119 26.4231,13.5045 26.4629,13.4892 C26.5026,13.474 26.5387,13.4512 26.5692,13.4223 C26.5998,13.3934 26.6242,13.3588 26.6409,13.3206 C26.6576,13.2825 26.6663,13.2414 26.6667,13.2 L26.6667,8.8444 C26.6667,8.6671 26.5173,8.5333 26.3381,8.5333 L21.3312,8.5333 L21.3312,3.8667 C21.3312,3.6894 21.1819,3.5556 21.0027,3.5556 L5.6704,3.5556 C5.5834,3.5539 5.4993,3.5857 5.4362,3.6439 C5.3731,3.7021 5.3361,3.7822 5.3333,3.8667 L5.3333,8.2222 C5.3333,8.3996 5.4827,8.5333 5.6704,8.5333"
      fill="currentColor"
    />
  </svg>
);

export const CloudflareSVG = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M21.9908,23.2 C22.1707,22.5067 22.0974,21.8894 21.776,21.416 C21.4894,20.9787 20.9867,20.7241 20.376,20.7241 L8.8253,20.5787 C8.7881,20.5794 8.7514,20.5694 8.7195,20.55 C8.6877,20.5307 8.662,20.5028 8.6453,20.4693 C8.6093,20.3973 8.6093,20.3241 8.6093,20.2521 C8.6453,20.1428 8.7533,20.0332 8.8613,20.0332 L20.52,19.8866 C21.92,19.8146 23.3906,18.6866 23.928,17.304 L24.6094,15.5573 C24.6453,15.484 24.6453,15.4107 24.6453,15.3387 C23.8933,11.88 20.88,9.3333 17.256,9.3333 C13.9187,9.3333 11.0853,11.5173 10.0813,14.5373 C9.7436,14.2751 9.3573,14.0822 8.9447,13.9699 C8.5321,13.8575 8.1014,13.8279 7.6773,13.8827 C6.064,14.028 4.8067,15.3387 4.628,16.976 C4.592,17.4133 4.628,17.8133 4.7,18.176 C2.08,18.2507 0,20.4347 0,23.0921 C0,23.3454 0.036,23.5653 0.036,23.8187 C0.036,23.928 0.1427,24.0012 0.2507,24.0012 L21.5612,24.0012 C21.6679,24.0012 21.8119,23.928 21.848,23.7826 L21.9908,23.2"
      fill="#F38020"
    />
    <path
      d="M25.6507,15.6666 L25.328,15.6666 C25.256,15.6666 25.184,15.7386 25.1479,15.812 L24.6812,17.412 C24.5026,18.1052 24.5746,18.7227 24.8972,19.1959 C25.184,19.6332 25.6866,19.8866 26.2972,19.8866 L28.7707,20.0332 C28.8427,20.0332 28.9147,20.0693 28.9506,20.1426 C28.9867,20.2146 28.9867,20.288 28.9867,20.36 C28.9506,20.4693 28.8427,20.5787 28.736,20.5787 L26.1893,20.7253 C24.7893,20.7973 23.3186,21.9253 22.7799,23.3079 L22.6012,23.7813 C22.5653,23.8546 22.6359,23.9639 22.744,23.9639 L31.5333,23.9639 C31.6412,23.9639 31.7493,23.8907 31.7493,23.7813 C31.8919,23.2347 32,22.6533 32,22.0347 C31.9639,18.5413 29.1292,15.6653 25.6507,15.6653"
      fill="#FCAD32"
    />
  </svg>
);

export const DifySVG = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M28.4444,5.336 L28.4444,8.6168 L22.6368,8.6168 L22.6368,11.899 L28.4444,11.899 L28.4444,15.1798 L22.6368,15.1798 L22.6368,23.3858 L28.4444,23.3858 L28.4444,26.6667 L3.5556,26.6667 L3.5556,23.3858 L9.0324,23.3858 L9.0324,15.1798 L4.386,15.1798 L4.386,11.899 L12.6823,11.899 L12.6823,23.3884 L18.9909,23.3884 L18.9909,15.1825 L15.175,15.1825 L15.175,11.9016 L18.9895,11.9016 L18.9895,10.4239 L18.9842,10.4239 C18.9851,9.076 19.528,7.7834 20.4924,6.8297 C21.4569,5.8762 22.7643,5.3386 24.1289,5.336 L28.4444,5.336"
      fill="currentColor"
    />
    <path
      d="M10.8607,5.3333 C12.5579,5.3335 13.1831,6.3615 13.1833,7.6312 C13.1833,8.9013 12.5549,9.9292 10.8594,9.9292 C9.162,9.929 8.5342,8.9012 8.5342,7.6312 C8.5343,6.3604 9.1613,5.3333 10.8607,5.3333"
      fill="currentColor"
    />
  </svg>
);

export const LiveKitAgentsSVG = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path
      d="M18.6667,13.3333 L13.3333,13.3333 L13.3333,18.6667 L18.6667,18.6667 L18.6667,13.3333 M24,8 L18.6667,8 L18.6667,13.3347 L24,13.3347 L24,8 M24,18.6667 L18.6667,18.6667 L18.6667,24 L24,24 L24,18.6667 M29.3333,2.6667 L24,2.6667 L24,8 L29.3333,8 L29.3333,2.6667 M29.3333,24 L24,24 L24,29.3333 L29.3333,29.3333 L29.3333,24"
      fill="#1FD5F9"
    />
    <path
      d="M8,24 L8,2.6667 L2.6667,2.6667 L2.6667,29.3333 L18.6667,29.3333 L18.6667,24 L8,24"
      fill="currentColor"
    />
  </svg>
);

export const OpenRouterSVG = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <g clipPath="url(#openrouter-clip)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.4053,2.6093 L32.032,8.0826 L32.032,8.1986 L22.3067,13.6133 L22.3292,10.7906 L21.2347,10.7506 C19.8226,10.7133 19.0866,10.7533 18.2107,10.8973 C16.792,11.1306 15.4933,11.6666 14.0147,12.7 L11.1267,14.7066 C10.748,14.9666 10.4667,15.1546 10.22,15.3133 L9.5333,15.7426 L9.004,16.0546 L9.5173,16.3613 L10.224,16.812 C10.8587,17.2306 11.784,17.8732 13.8253,19.2999 C15.3053,20.3333 16.6027,20.8693 18.0213,21.1026 L18.4213,21.1627 C19.3467,21.2839 20.2548,21.288 22.1881,21.2066 L22.2174,18.328 L31.8439,23.8012 L31.8439,23.9173 L22.1188,29.3333 L22.1374,26.8507 L21.2907,26.88 C19.4427,26.936 18.4412,26.8827 17.1067,26.664 C14.848,26.2907 12.76,25.4293 10.5987,23.9186 L7.7213,21.9186 C7.3904,21.6905 7.0547,21.469 6.7147,21.2546 L6.092,20.8812 C5.7557,20.6876 5.4179,20.4965 5.0787,20.3079 C3.8773,19.64 0.7507,18.8213 0,18.8213 L0,13.184 L0.1867,13.1893 C0.9387,13.18 4.0667,12.36 5.2653,11.6906 L6.62,10.9173 L7.204,10.552 C7.7747,10.1786 8.6333,9.584 10.7853,8.0813 C12.9467,6.5706 15.0333,5.708 17.2933,5.336 C18.8293,5.0826 19.9253,5.052 22.3787,5.152 L22.4053,2.6093"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="openrouter-clip">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const RubyLLMSVG = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <g clipPath="url(#rubyllm-clip)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.961,22.9577 L2.3788,19.2523 L15.0349,30.2841 L27.8827,19.2439 L16.961,22.9577"
        fill="#CA1D15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0625,30.2953 L21.0652,22.2464 L14.6313,23.1396 L15.0625,30.2953"
        fill="#8D1206"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0763,30.309 L8.1977,22.27 L2.4337,19.2764 L15.0763,30.309"
        fill="#8D1206"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.4427,19.2885 L10.4067,15.0422 L5.4278,11.8225 L2.4427,19.2885"
        fill="#CA1D15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6103,23.1591 L19.6052,14.726 L10.0998,14.4254 L14.6103,23.1591"
        fill="#CA1D15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.525,20.8265 L24.669,12.4015 L19.2044,15.2891 L25.525,20.8265"
        fill="#CA1D15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.4892,13.5172 L24.2533,12.2999 L24.0578,9.0516 L28.4892,13.5172"
        fill="#8D1206"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.3022,12.7934 L5.5282,11.8498 L7.0841,8.4418 L2.3022,12.7934"
        fill="#CA1D15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.1009,8.3019 L5.3956,11.871 L10.3453,15.0018 L19.2466,15.3214 L24.6821,12.484 L24.077,8.9868 L19.2857,6.8092 C17.1662,6.734 13.0144,6.627 12.8995,6.5882 C12.7847,6.5511 8.9386,7.7385 7.1009,8.3019"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1042,6.8227 C19.8437,6.8396 24.3072,8.5104 24.2985,10.8758 C24.2889,13.2404 20.1552,14.8825 15.4164,14.8648 C10.6775,14.8471 6.1753,13.2912 6.185,10.9266 C6.193,8.562 10.3653,6.8051 15.1042,6.8227"
        fill="#CA1D15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.4451,19.2862 L10.414,15.0058 L14.5868,23.1147 C10.2854,22.9794 6.0564,22.2732 2.4451,19.2862"
        fill="#A5130E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2668,15.3174 L14.6055,23.1397 C18.4094,23.0416 22.1694,22.6071 25.5758,20.8272 L19.2668,15.3174"
        fill="#A5130E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.5282,20.8427 C28.0617,19.568 30.9364,16.9806 28.4665,13.501 L24.6772,12.4111 L25.5282,20.8427"
        fill="#8D1206"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.3297,12.7658 C-0.7225,15.9971 1.4991,18.3092 2.4378,19.3015 L5.4109,11.8604 L2.3297,12.7658"
        fill="#A5130E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.266,15.3359 C19.8165,17.6362 20.9328,22.266 20.9586,22.3564 C20.9982,22.498 24.1314,21.6572 25.5136,20.7941 L19.266,15.3359"
        fill="#8D1206"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4115,15.0034 L8.1201,22.2443 C10.3743,22.9115 12.4842,23.0887 14.5666,23.101 L10.4115,15.0034"
        fill="#8D1206"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.3947,11.8572 L0.8778,15.6798 C0.6371,17.2431 1.4683,18.2299 2.4927,19.1122 C3.518,16.7049 5.5694,11.8926 5.3947,11.8572"
        fill="#8D1206"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.6521,12.4071 L28.8764,18.0027 C29.7239,16.6297 29.6347,15.1086 28.486,13.5139 L24.6521,12.4071"
        fill="#CA1D15"
      />
      <path
        d="M18.0041,4.138 L29.2469,4.138 L29.2469,3.116 L18.0041,3.116 L18.0041,4.138"
        fill="black"
      />
      <path
        d="M18.008,4.138 L16.9849,4.138 L16.9849,5.1638 L18.008,5.1638 L18.008,4.138"
        fill="black"
      />
      <path
        d="M30.27,4.138 L29.2469,4.138 L29.2469,5.1638 L30.27,5.1638 L30.27,4.138"
        fill="black"
      />
      <path
        d="M30.2661,5.1638 L30.2661,12.3372 L31.2892,12.3372 L31.2892,5.1638 L30.2661,5.1638"
        fill="black"
      />
      <path
        d="M21.0734,8.2376 L20.0503,8.2376 L20.0503,9.2634 L21.0734,9.2634 L21.0734,8.2376"
        fill="black"
      />
      <path
        d="M24.139,8.2376 L23.1159,8.2376 L23.1159,9.2634 L24.139,9.2634 L24.139,8.2376"
        fill="black"
      />
      <path
        d="M27.2044,8.2376 L26.1813,8.2376 L26.1813,9.2634 L27.2044,9.2634 L27.2044,8.2376"
        fill="black"
      />
      <path
        d="M16.9848,12.3372 L16.9848,5.1638 L15.9617,5.1638 L15.9617,12.3372 L16.9848,12.3372"
        fill="black"
      />
      <path
        d="M18.008,12.3372 L16.9849,12.3372 L16.9849,13.363 L18.008,13.363 L18.008,12.3372"
        fill="black"
      />
      <path
        d="M30.27,12.3372 L29.2469,12.3372 L29.2469,13.363 L30.27,13.363 L30.27,12.3372"
        fill="black"
      />
      <path
        d="M22.0928,13.3592 L18.0041,13.3592 L18.0041,14.3851 L22.0928,14.3851 L22.0928,13.3592"
        fill="black"
      />
      <path
        d="M29.2469,13.3592 L25.1582,13.3592 L25.1582,14.3851 L29.2469,14.3851 L29.2469,13.3592"
        fill="black"
      />
      <path
        d="M23.1159,14.3851 L22.0928,14.3851 L22.0928,15.411 L23.1159,15.411 L23.1159,14.3851"
        fill="black"
      />
      <path
        d="M25.1582,14.3851 L24.1351,14.3851 L24.1351,15.411 L25.1582,15.411 L25.1582,14.3851"
        fill="black"
      />
      <path
        d="M24.139,15.4109 L23.1159,15.4109 L23.1159,16.4368 L24.139,16.4368 L24.139,15.4109"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9848,12.3371 L16.9848,5.1638 L18.008,5.1638 L18.008,4.1379 L29.2468,4.1379 L29.2468,5.1638 L30.2661,5.1638 L30.2661,12.3371 L29.2468,12.3371 L29.2468,13.3591 L25.1582,13.3591 L25.1582,14.385 L24.1351,14.385 L24.1351,15.4108 L23.1157,15.4108 L23.1157,14.385 L22.0926,14.385 L22.0926,13.3591 L18.008,13.3591 L18.008,12.3371 L16.9848,12.3371 M21.0734,8.2375 L20.0503,8.2375 L20.0503,9.2634 L21.0734,9.2634 L21.0734,8.2375 M24.1388,8.2375 L23.1157,8.2375 L23.1157,9.2634 L24.1388,9.2634 L24.1388,8.2375 M27.2044,8.2375 L26.1813,8.2375 L26.1813,9.2634 L27.2044,9.2634 L27.2044,8.2375"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="rubyllm-clip">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const StrandsAgentsSVG = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <g clipPath="url(#strands-clip)">
      <path
        d="M12.7134,3.6493 C11.8675,3.3987 10.9786,3.8812 10.728,4.7271 C10.4773,5.573 10.9599,6.4618 11.8058,6.7125 L22.2521,9.6694 C22.9515,9.8766 23.0299,10.8357 22.3737,11.1539 L8.2327,18.01 C4.946,19.6034 5.3462,24.408 8.8512,25.4359 L19.0985,28.4407 L19.1383,28.4517 C19.9726,28.6736 20.8366,28.1908 21.0811,27.3573 C21.3292,26.5108 20.8441,25.6231 19.9975,25.3748 L9.7502,22.37 C9.0492,22.1644 8.9692,21.2036 9.6265,20.8848 L23.7675,14.0288 C27.0491,12.4377 26.6564,7.6422 23.1596,6.6061 L12.7134,3.6493"
        fill="#989898"
      />
      <path
        d="M23.9152,0.0639 C24.7623,-0.1823 25.6487,0.305 25.8949,1.1522 C26.1412,1.9994 25.6539,2.8858 24.8066,3.132 L10.906,7.1707 C8.7981,7.7832 8.5547,10.672 10.5305,11.6285 L22.683,17.5118 C27.2873,19.7408 26.7282,26.4708 21.8192,27.9097 L8.0846,31.9351 C7.2379,32.1833 6.3504,31.6981 6.1023,30.8516 C5.8542,30.0048 6.3393,29.1173 7.186,28.8692 L20.9207,24.8437 C23.0245,24.227 23.264,21.3428 21.2908,20.3874 L9.1383,14.5042 C4.5282,12.2723 5.0961,5.5318 10.0146,4.1027 L23.9152,0.0639"
        fill="#00FF77"
      />
    </g>
    <defs>
      <clipPath id="strands-clip">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TraceLoopSVG = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <g clipPath="url(#traceloop-clip)">
      <rect
        y="5.8182"
        width="17.4545"
        height="2.9091"
        rx="1.4545"
        fill="#FD3B5D"
      />
      <rect
        y="17.4545"
        width="5.8182"
        height="2.9091"
        rx="1.4545"
        fill="#F9A730"
      />
      <rect
        y="23.2727"
        width="5.8182"
        height="2.9091"
        rx="1.4545"
        fill="#02FF80"
      />
      <rect
        y="11.6364"
        width="11.6364"
        height="2.9091"
        rx="1.4545"
        fill="#F9A730"
      />
      <rect
        x="8.7273"
        y="17.4545"
        width="8.7273"
        height="2.9091"
        rx="1.4545"
        fill="#00C3FD"
      />
      <rect
        x="8.7273"
        y="23.2727"
        width="11.6364"
        height="2.9091"
        rx="1.4545"
        fill="#FD3B5D"
      />
      <rect
        x="20.3636"
        y="5.8182"
        width="11.6364"
        height="2.9091"
        rx="1.4545"
        fill="#FCE600"
      />
      <rect
        x="14.5455"
        y="11.6364"
        width="8.7273"
        height="2.9091"
        rx="1.4545"
        fill="#02FF80"
      />
      <rect
        x="20.3636"
        y="17.4545"
        width="11.6364"
        height="2.9091"
        rx="1.4545"
        fill="#FCE600"
      />
      <rect
        x="23.2727"
        y="23.2727"
        width="8.7273"
        height="2.9091"
        rx="1.4545"
        fill="#00C3FD"
      />
      <rect
        x="26.1819"
        y="11.6364"
        width="5.8182"
        height="2.9091"
        rx="1.4545"
        fill="#F9A730"
      />
    </g>
    <defs>
      <clipPath id="traceloop-clip">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TanStackAISVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 663 660"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m305.114318.62443771c8.717817-1.14462121 17.926803-.36545135 26.712694-.36545135 32.548987 0 64.505987 5.05339923 95.64868 14.63098274 39.74418 12.2236582 76.762804 31.7666864 109.435876 57.477568 40.046637 31.5132839 73.228974 72.8472109 94.520714 119.2362609 39.836383 86.790386 39.544267 191.973146-1.268422 278.398081-26.388695 55.880442-68.724007 102.650458-119.964986 136.75724-41.808813 27.828603-90.706831 44.862601-140.45707 50.89341-63.325458 7.677926-131.784923-3.541603-188.712259-32.729444-106.868873-54.795293-179.52309291-165.076271-180.9604082-285.932068-.27660564-23.300971.08616998-46.74071 4.69884909-69.814998 7.51316071-37.57857 20.61272131-73.903917 40.28618971-106.877282 21.2814003-35.670293 48.7704861-67.1473767 81.6882804-92.5255597 38.602429-29.7610135 83.467691-51.1674988 130.978372-62.05777669 11.473831-2.62966514 22.9946-4.0869914 34.57273-5.4964306l3.658171-.44480576c3.050084-.37153079 6.104217-.74794222 9.162589-1.14972654zm-110.555861 549.44131429c-14.716752 1.577863-30.238964 4.25635-42.869928 12.522173 2.84343.683658 6.102369.004954 9.068638 0 7.124652-.011559 14.317732-.279903 21.434964.032202 17.817402.781913 36.381729 3.63214 53.58741 8.350042 22.029372 6.040631 41.432961 17.928687 62.656049 25.945156 22.389644 8.456554 44.67706 11.084675 68.427 11.084675 11.96813 0 23.845573-.035504 35.450133-3.302696-6.056202-3.225083-14.72582-2.619864-21.434964-3.963236-14.556814-2.915455-28.868774-6.474936-42.869928-11.470264-10.304996-3.676672-20.230803-8.214291-30.11097-12.848661l-6.348531-2.985046c-9.1705-4.309263-18.363277-8.560752-27.845391-12.142608-24.932161-9.418465-52.560181-14.071964-79.144482-11.221737zm22.259385-62.614168c-29.163917 0-58.660076 5.137344-84.915434 18.369597-6.361238 3.206092-12.407546 7.02566-18.137277 11.258891-1.746125 1.290529-4.841829 2.948483-5.487351 5.191839-.654591 2.275558 1.685942 4.182039 3.014086 5.637703 6.562396-3.497556 12.797498-7.199878 19.78612-9.855246 45.19892-17.169893 99.992458-13.570779 145.098218 2.172348 22.494346 7.851335 43.219483 19.592421 65.129314 28.800338 24.503461 10.297807 49.53043 16.975034 75.846795 20.399104 31.04195 4.037546 66.433549.7654 94.808495-13.242161 9.970556-4.921843 23.814245-12.422267 28.030337-23.320339-5.207047.454947-9.892236 2.685918-14.83959 4.224149-7.866632 2.445646-15.827248 4.51974-23.908229 6.138887-27.388113 5.486604-56.512458 6.619429-84.091013 1.639788-25.991939-4.693152-50.142596-14.119246-74.179513-24.03502l-3.068058-1.268177c-2.045137-.846788-4.089983-1.695816-6.135603-2.544467l-3.069142-1.272366c-12.279956-5.085721-24.606928-10.110797-37.210937-14.51024-24.485325-8.546552-50.726667-13.784628-76.671218-13.784628zm51.114145-447.9909432c-34.959602 7.7225298-66.276908 22.7605319-96.457338 41.7180089-17.521434 11.0054099-34.281927 22.2799893-49.465301 36.4444283-22.5792616 21.065423-39.8360564 46.668751-54.8866988 73.411509-15.507372 27.55357-25.4498976 59.665686-30.2554517 90.824149-4.7140432 30.568106-5.4906485 62.70747-.0906864 93.301172 6.7503648 38.248526 19.5989769 74.140579 39.8896436 107.337631 6.8187918-3.184625 11.659796-10.445603 17.3128555-15.336896 11.4149428-9.875888 23.3995608-19.029311 36.2745548-26.928535 4.765981-2.923712 9.662222-5.194315 14.83959-7.275014 1.953055-.785216 5.14604-1.502727 6.06527-3.647828 1.460876-3.406732-1.240754-9.335897-1.704904-12.865654-1.324845-10.095517-2.124534-20.362774-1.874735-30.549941.725492-29.668947 6.269727-59.751557 16.825623-87.521453 7.954845-20.924233 20.10682-39.922168 34.502872-56.971512 4.884699-5.785498 10.077731-11.170545 15.437296-16.512656 3.167428-3.157378 7.098271-5.858983 9.068639-9.908915-10.336599.006606-20.674847 2.987289-30.503603 6.013385-21.174447 6.519522-41.801477 16.19312-59.358362 29.841512-8.008432 6.226409-13.873368 14.387371-21.44733 20.939921-2.32322 2.010516-6.484901 4.704691-9.695199 3.187928-4.8500728-2.29042-4.1014979-11.835213-4.6571581-16.222019-2.1369011-16.873476 4.2548401-38.216325 12.3778671-52.843142 13.039878-23.479694 37.150915-43.528712 65.467327-42.82854 12.228647.302197 22.934587 4.551115 34.625711 7.324555-2.964621-4.211764-6.939158-7.28162-10.717482-10.733763-9.257431-8.459031-19.382979-16.184864-30.503603-22.028985-4.474136-2.350694-9.291232-3.77911-14.015169-5.506421-2.375159-.867783-5.36616-2.062533-6.259834-4.702213-1.654614-4.888817 7.148561-9.416813 10.381943-11.478522 12.499882-7.969406 27.826705-14.525258 42.869928-14.894334 23.509209-.577147 46.479246 12.467678 56.162903 34.665926 3.404469 7.803171 4.411273 16.054969 5.079109 24.382907l.121749 1.56229.174325 2.345587c.01913.260708.038244.521433.057403.782164l.11601 1.56437.120128 1.563971c7.38352-6.019164 12.576553-14.876995 19.78612-21.323859 16.861073-15.07846 39.936636-21.7722 61.831627-14.984333 19.786945 6.133107 36.984382 19.788105 47.105807 37.959541 2.648042 4.754231 10.035685 16.373942 4.698379 21.109183-4.177345 3.707277-9.475079.818243-13.880788-.719162-3.33605-1.16376-6.782939-1.90214-10.241828-2.585698l-1.887262-.369639c-.629089-.122886-1.257979-.246187-1.886079-.372129-11.980496-2.401886-25.91652-2.152533-37.923398-.041284-7.762754 1.364839-15.349083 4.127545-23.083807 5.271929v1.651348c21.149714.175043 41.608563 12.240618 52.043268 30.549941 4.323267 7.585468 6.482428 16.267431 8.138691 24.770223 2.047864 10.50918.608423 21.958802-2.263037 32.201289-.962925 3.433979-2.710699 9.255807-6.817143 10.046802-2.902789.558982-5.36781-2.330878-7.024898-4.279468-4.343878-5.10762-8.475879-9.96341-13.573278-14.374161-12.895604-11.157333-26.530715-21.449361-40.396663-31.373138-7.362086-5.269452-15.425755-12.12007-23.908229-15.340199 2.385052 5.745041 4.721463 11.086326 5.532694 17.339156 2.385876 18.392716-5.314223 35.704625-16.87179 49.540445-3.526876 4.222498-7.29943 8.475545-11.744712 11.755948-1.843407 1.360711-4.156734 3.137561-6.595373 2.752797-7.645687-1.207961-8.555849-12.73272-9.728176-18.637115-3.970415-19.998652-2.375984-39.861068 3.132802-59.448534-4.901187 2.485279-8.443727 7.923994-11.521293 12.385111-6.770975 9.816439-12.645804 20.199291-16.858599 31.375615-16.777806 44.519521-16.616219 96.664142 5.118834 139.523233 2.427098 4.786433 6.110614 4.144058 10.894733 4.144058.720854 0 1.44257-.004515 2.164851-.010924l2.168232-.022283c4.338648-.045438 8.686803-.064635 12.979772.508795 2.227588.297243 5.320818.032202 7.084256 1.673642 2.111344 1.966755.986008 5.338808.4996 7.758859-1.358647 6.765574-1.812904 12.914369-1.812904 19.816178 9.02412-1.398692 11.525415-15.866153 14.724172-23.118874 3.624982-8.216283 7.313444-16.440823 10.667192-24.770223 1.648843-4.093692 3.854171-8.671229 3.275427-13.210785-.649644-5.10184-4.335633-10.510831-6.904531-14.862134-4.86244-8.234447-10.389363-16.70834-13.969002-25.595896-2.861567-7.104926-.197036-15.983399 7.871579-18.521521 4.450228-1.400344 9.198073 1.345848 12.094266 4.562675 6.07269 6.74328 9.992815 16.777697 14.401823 24.692609l34.394873 61.925556c2.920926 5.243856 5.848447 10.481933 8.836976 15.687808 1.165732 2.031158 2.352075 5.167068 4.740424 6.0332 2.127008.77118 5.033095-.325315 7.148561-.748886 5.492297-1.099798 10.97635-2.287117 16.488434-3.28288 6.605266-1.193099 16.673928-.969342 21.434964-6.129805-6.963066-2.205375-15.011895-2.074919-22.259386-1.577863-4.352947.298894-9.178287 1.856116-13.178381-.686135-5.953149-3.783239-9.910373-12.522173-13.552668-18.377854-8.980425-14.439388-17.441465-29.095929-26.041008-43.760726l-1.376261-2.335014-2.765943-4.665258c-1.380597-2.334387-2.750786-4.67476-4.079753-7.036188-1.02723-1.826391-2.549937-4.233231-1.078344-6.24705 1.545791-2.114476 4.91472-2.239146 7.956473-2.243117l.603351.000261c1.195428.001526 2.315572.002427 3.222811-.11692 12.27399-1.615019 24.718635-2.952611 37.098976-2.952611-.963749-3.352237-3.719791-7.141255-2.838484-10.73046 1.972017-8.030506 13.526287-10.543033 18.899867-4.780653 3.60767 3.868283 5.704174 9.192229 8.051303 13.859765 3.097352 6.162006 6.624228 12.118418 9.940876 18.16483 5.805578 10.585967 12.146205 20.881297 18.116667 31.375615.49237.865561.999687 1.726685 1.512269 2.587098l.771613 1.290552c2.577138 4.303168 5.164895 8.635123 6.553094 13.461506-20.735854-.9487-36.30176-25.018751-45.343193-41.283704-.721369 2.604176.450959 4.928448 1.388326 7.431066 1.948109 5.197619 4.276275 10.147535 7.20627 14.862134 4.184765 6.732546 8.982075 13.665732 15.313633 18.553722 11.236043 8.673707 26.05255 8.721596 39.572241 7.794364 8.669619-.595311 19.50252-4.542034 28.030338-1.864372 8.513803 2.673532 11.940924 12.063098 6.884745 19.276187-3.787393 5.403211-8.842747 7.443452-15.128962 8.257566 4.445282 9.53571 10.268996 18.385285 14.490036 28.072919 1.758491 4.035895 3.59118 10.22102 7.8048 12.350433 2.805507 1.416857 6.824562.09743 9.85761.034678-3.043765-8.053625-8.742992-14.887729-11.541904-23.118874 8.533589.390544 16.786875 4.843404 24.732651 7.685374 15.630376 5.590144 31.063836 11.701854 46.475333 17.86913l7.112077 2.848685c6.338978 2.538947 12.71588 5.052299 18.961699 7.812528 2.285297 1.009799 5.449427 3.370401 7.975455 1.917215 2.061054-1.186494 3.394144-4.015253 4.665403-5.931643 3.55573-5.361927 6.775921-10.928622 9.965609-16.513481 12.774414-22.36586 22.143967-46.872692 28.402976-71.833646 20.645168-82.323009 2.934117-173.156241-46.677107-241.922507-19.061454-26.420745-43.033164-49.262193-69.46165-68.1783861-66.13923-47.336721-152.911262-66.294198-232.486917-48.7172481zm135.205158 410.5292842c-17.532977 4.570931-35.601827 8.714164-53.58741 11.040088 2.365265 8.052799 8.145286 15.885969 12.376218 23.118874 1.635653 2.796558 3.3859 6.541816 6.618457 7.755557 3.651364 1.370619 8.063669-.853747 11.508927-1.975838-1.595256-4.364513-4.279573-8.292245-6.476657-12.385112-.905215-1.687677-2.305907-3.685809-1.559805-5.68972 1.410585-3.786541 7.266452-3.563609 10.509727-4.221671 8.54678-1.733916 17.004522-3.898008 25.557073-5.611281 3.150939-.631641 7.538512-2.342438 10.705115-1.285575 2.371037.791232 3.800147 2.744743 5.152304 4.781948l.606196.918752c.80912 1.222827 1.637246 2.41754 2.671212 3.351165 3.457625 3.121874 8.628398 3.60159 13.017619 4.453686-2.678546-6.027421-7.130424-11.301001-9.984571-17.339156-1.659561-3.511592-3.023155-8.677834-6.656381-10.707341-5.005064-2.795733-15.341663 2.461334-20.458024 3.795624zm-110.472507-40.151706c-.825246 10.467897-4.036369 18.984725-9.068639 28.072919 5.76683.729896 11.649079.989984 17.312856 2.39363 4.244947 1.051908 8.156828 3.058296 12.366325 4.211763-2.250671-6.157877-6.426367-11.651913-9.661398-17.339156-3.266358-5.740912-6.189758-12.717032-10.949144-17.339156z"
      transform="translate(.9778)"
      fill="currentColor"
    />
  </svg>
);

/**
 * Registry of all integration icons keyed by component name.
 * Used by stories and anywhere a complete list is needed.
 */
export const INTEGRATION_ICONS: Record<string, () => React.JSX.Element> = {
  AgnoSVG,
  AnthropicSVG,
  AutogenSVG,
  BasetenSVG,
  BedrockSVG,
  BeeAISVG,
  ClaudeSVG,
  CloudflareSVG,
  CrewAISVG,
  DifySVG,
  DSPYSVG,
  GeminiSVG,
  GoogleADKSVG,
  GroqSVG,
  HaystackSVG,
  HuggingFaceSVG,
  IntegrationSVG,
  LangChainSVG,
  LangGraphSVG,
  LiteLLMSVG,
  LiveKitAgentsSVG,
  LlamaIndexSVG,
  MastraSVG,
  McpSVG,
  MistralAISVG,
  NodeJSSVG,
  OpenAISVG,
  OpenRouterSVG,
  PortkeySVG,
  PydanticAISVG,
  RubyLLMSVG,
  StrandsAgentsSVG,
  TanStackAISVG,
  TraceLoopSVG,
  VercelSVG,
  VertexAISVG,
};
